/* jslint laxcomma:true */
/* jslint laxbreak:true */
/* jslint shadow:true */

/**
 * Array.prototype.includes polyfill for IE/Edge
 * https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Array/includes
 */
var array_includes = function (arr, searchElement /*, fromIndex*/) {
  "use strict";
  var O = Object(arr);
  var len = parseInt(O.length, 10) || 0;
  if (len === 0) {
    return false;
  }
  var n = parseInt(arguments[2], 10) || 0;
  var k;
  if (n >= 0) {
    k = n;
  } else {
    k = len + n;
    if (k < 0) {
      k = 0;
    }
  }
  var currentElement;
  while (k < len) {
    currentElement = O[k];
    if (searchElement === currentElement) {
      // NaN !== NaN
      return true;
    }
    k++;
  }
  return false;
};

var scrollAnimation = false;

//window.SVGPathElement.prototype.getBBox = raphGetBBox;

/**
 * Creates a new SVG Viewer
 * @author Alex Gryson <agr@sculpteo.com>
 * @author Ivica Arsov <iar@sculpteo.com>
 * @copyright Sculpteo 2016
 *
 * @module SvgViewer
 * @param {string} design_path - Path to the design to load
 * @param {bool} legend - Whether to load in legend mode [true] or simple viewer mode [false]
 */
var SvgViewer = (function (SvgViewer) {
  /*************************************************/
  /*                     CONSTANTS                 */
  /*************************************************/
  var isLoaded = false;
  var isLegendModeEnabled = false;
  var isScaleCheckModeEnabled = false;
  var isMeasuringModeEnabled = false;
  var isShowIssuesModeEnabled = false;

  var svgViewport = null;
  var svgBBox = null;
  var svgDim = 1;
  var uiLayer = null;
  var svgBboxOutline = null;
  var svgBboxOutlineRect = null;
  var svgBboxZoomHack = null;
  var svgQuestionmark = null;
  var svgQuestionmarkBBox = null;
  var svgModified = false;
  var touchEventSelected = null;

  var featureSupport = {
    Path: true,
    CompoundPath: true,
  };

  var unsupportedColors = [
    "none",
    "",
    "#fff",
    "#FFF",
    "#ffffff",
    "#FFFFFF",
    undefined,
    "white",
    "rgb(255, 255, 255)",
    "rgb(255,255,255)",
  ];

  var configLayer = null;
  var configModel = {
    group_array: [],
    elems: [],
    lsrModel: null,
    elemsBBox: [],
    cutTypes: null,
  };

  var enableRenderLayer = false;
  var renderLayer = null;
  var renderModel = {
    group_array: [],
    elems: [],
    lsrModel: null,
    elemsBBox: [],
    cutTypes: null,
  };

  var activeLayer = null;
  var activeModel = null;

  var selectionRect = null;
  var selectionSet = [];
  var selectionState = [];
  var selectionStateTemp = [];
  var newScale = 1;
  var scale = 1;
  var mm_scale = 1;
  var design_unit;
  var units;
  var save_timeout;
  var selectedBBox = null;
  var zoomStep = 0.1;

  var dimensionsGroup = null;
  var dimensionsWidth = null;
  var dimensionsHeight = null;

  var backgroundLayer = null;
  var backgroundGroup = null;
  var backgroundLoading = false;
  var backgroundVisible = false;
  var materialBackground = null;
  var materialCutColor = null;
  var materialLinearColor = null;
  var materialEngraveColor = null;
  var materialDeepColor = null;

  var gridGroup = null;
  var drawGrid = false;
  var zoom0 = 0;

  var lasercutCutMap = [];
  var computeGridScaleFunc = computeGridScale;
  var gridSizeCallback = null;

  var measureSign = null;
  var measurePoint = null;
  var measurePoint0 = null;
  var measureShape0 = null;
  var measureShapeLines0 = [null, null];
  var measurePoint1 = null;
  var measureShape1 = null;
  var measureShapeLines1 = [null, null];
  var measureLine = null;

  var issuesLayer = null;

  var legendInit = function (model) {
    /*************** Initialization ***************/

    paper.settings.insertItems = false;
    computeGridScaleFunc = computeGridScale;
    // This means we loaded an svg in production validation
    if (!model) {
      computeGridScaleFunc = computeGridScaleMetric;
      var gridLayer = new paper.Layer();
      paper.project.addLayer(gridLayer);
      gridGroup = new paper.Group();
      gridLayer.addChild(gridGroup);
      drawGrid = true;
      var findElems = function (elems, root) {
        if (!root.children) {
          return;
        }
        for (var i = 0; i < root.children.length; ++i) {
          var child = root.children[i];
          if (featureSupport[child.className]) {
            elems.push(child);
          } else {
            findElems(elems, child);
          }
        }
      };

      configModel.elems = [];

      configLayer = paper.project.getItems()[0].getChildren()[0];

      findElems(configModel.elems, configLayer);

      for (var i = 0; i < configModel.elems.length; ++i) {
        var elem = configModel.elems[i];

        if (!elem.name || !elem.name.startsWith("P")) {
          continue;
        }
        var id = parseInt(elem.name.substring(1));
        if (isNaN(id)) {
          continue;
        }

        if (lasercutCutMap[id]) {
          elem._lasercut_stroke_type = parseInt(lasercutCutMap[id].stroke);
          elem._lasercut_fill_type = parseInt(lasercutCutMap[id].fill);
        }
      }

      var tool = new paper.Tool();

      var pan = false;
      var hoverItem = null;

      tool.onMouseDown = function (e) {
        if (
          e.event.type == "touchstart" ||
          e.event.button == 0 ||
          e.event.button == 1
        ) {
          pan = true;
        }
      };

      tool.onMouseDrag = function (e) {
        if (pan) {
          paper.view.center = paper.view.center.subtract(
            e.point.subtract(e.downPoint)
          );
          gridGroup.fitBounds(paper.view.bounds);
        }
      };

      tool.onMouseUp = function (e) {
        pan = false;
      };

      svgBboxZoomHack = paper.project.activeLayer.bounds.clone();
      svgBBox = configLayer.bounds;
      svgDim = Math.max(svgBBox.width, svgBBox.height);
      svgDim /= 200.0;
      svgBboxOutlineRect = new paper.Rectangle(
        svgBBox.x - svgDim * 6,
        svgBBox.y - svgDim * 6,
        svgBBox.width + svgDim * 12,
        svgBBox.height + svgDim * 12
      );
      updatePosition();
      zoom0 = 1 / paper.view.zoom;
      doDrawGrid();

      if (SvgViewer.on_viewer_initialized) {
        SvgViewer.on_viewer_initialized();
      }
      return;
    }

    gridLayer = paper.project.activeLayer;
    gridGroup = new paper.Group();
    gridLayer.addChild(gridGroup);

    backgroundLayer = new paper.Layer();
    paper.project.addLayer(backgroundLayer);

    configLayer = new paper.Layer();
    paper.project.addLayer(configLayer);

    renderLayer = new paper.Layer();
    renderLayer.visible = false;
    paper.project.addLayer(renderLayer);

    activeLayer = configLayer;

    cutTypeAllowed[1] = !(model.lsr_flags & 0x04);
    cutTypeAllowed[2] = !(model.lsr_flags & 0x08);
    cutTypeAllowed[3] = !(model.lsr_flags & 0x10);
    cutTypeAllowed[4] = !(model.lsr_flags & 0x20);

    var uniquePairs = loadModel(model, configModel, configLayer);

    activeModel = configModel;

    // Create the styles
    for (var i = 0; i < uniquePairs.length; i++) {
      createLegendLine(uniquePairs[i]);
    }

    var cutTypes = getCutTypes();
    svgBBox = configLayer.bounds;
    svgDim = Math.max(svgBBox.width, svgBBox.height);
    svgDim /= 200.0;

    svgBboxZoomHack = svgBBox.clone();
    svgQuestionmarkBBox = svgBBox.clone();

    createElementsBBoxList(configModel, cutTypes);

    updateSVGBBox();

    $(".colorCount").text(uniquePairs.length);
    $(".pluralCount").toggle(uniquePairs.length > 1);
    $(".singularCount").toggle(uniquePairs.length < 2);

    issuesLayer = new paper.Layer();
    paper.project.addLayer(issuesLayer);

    uiLayer = new paper.Layer();
    paper.project.addLayer(uiLayer);

    svgBboxOutlineRect = new paper.Rectangle(
      svgBBox.x - svgDim * 6,
      svgBBox.y - svgDim * 6,
      svgBBox.width + svgDim * 12,
      svgBBox.height + svgDim * 12
    );
    var cornerSize = new paper.Size(svgDim * 6, svgDim * 6);
    svgBboxOutline = new paper.Path.RoundRectangle(
      svgBboxOutlineRect,
      cornerSize
    );
    //svgBboxOutline.style.strokeColor = 'black';
    svgBboxOutline.strokeScaling = false;
    uiLayer.addChild(svgBboxOutline);

    svgQuestionmark = new paper.PointText();
    svgQuestionmark.fillColor = "#cccccc";
    svgQuestionmark.translate(svgBBox.width / 2, svgBBox.height / 2 + 10);
    svgQuestionmark.fontSize = svgBBox.height / 2;
    svgQuestionmark.justification = "center";
    svgQuestionmark.fontFamily = "PT-Sans, Helvetica, Arial, sans-serif";
    svgQuestionmark.content = "?";
    svgQuestionmark.visible = false;
    uiLayer.addChild(svgQuestionmark);

    /*************** EVENT HANDLERS ***************/

    tool = new paper.Tool();

    var getHitItem = function (point, tolerance, scale) {
      if (typeof scale === "undefined") {
        scale = true;
      }
      var scaled_tolerance = tolerance;
      if (scale) {
        scaled_tolerance *= paper.view.zoom;
      }

      var options = {
        stroke: true,
        fill: true,
        tolerance: scaled_tolerance,
      };
      options["class"] = paper.Path;

      if (measureSign) {
        measureSign.remove();
        measureSign = null;
        measurePoint = null;
      }

      var hitResult = null;
      if (isMeasuringModeEnabled) {
        // Find all hit elements
        var hitResults = activeLayer.hitTestAll(point, options);
        var guides = [];

        // Check if a cut element or guides are hit
        for (var i = hitResults.length - 1; i >= 0; --i) {
          var item = hitResults[i].item;
          var isElem = false;
          // We always take the topmost element
          if (item._lasercut_shape || item.parent._lasercut_shape) {
            if (hitResult) {
              if (
                Math.abs(hitResult.item.bounds.y - point.y) >
                Math.abs(hitResults[i].item.bounds.y - point.y)
              ) {
                hitResult = hitResults[i];
              }
            } else {
              hitResult = hitResults[i];
            }
          }
          if (item._lasercut_is_guide) {
            guides.push(hitResults[i]);
          }
        }

        if (hitResult && !hitResult.point) {
          hitResult.point = point;
        }

        if (guides.length || hitResult) {
          if (guides.length == 0) {
            // If there are no guides hit, just snap to the element
            measurePoint = hitResult.point.clone();
          } else {
            var guideHor = null;
            var guideVer = null;
            var numGuides = 0;
            // Find only one vertical and one horizontal guide, closest to the mouse pointer
            for (var i = guides.length - 1; i >= 0; --i) {
              if (guides[i].item.bounds.width > 0) {
                if (guideHor) {
                  if (
                    Math.abs(guideHor.item.bounds.y - point.y) >
                    Math.abs(guides[i].item.bounds.y - point.y)
                  ) {
                    guideHor = guides[i];
                  }
                } else {
                  guideHor = guides[i];
                  numGuides++;
                }
              } else {
                if (guideVer) {
                  if (
                    Math.abs(guideVer.item.bounds.x - point.x) >
                    Math.abs(guides[i].item.bounds.x - point.x)
                  ) {
                    guideVer = guides[i];
                  }
                } else {
                  guideVer = guides[i];
                  numGuides++;
                }
              }
            }

            var getIntersection = function (path, guide, hitResult) {
              var inters = path.getCrossings(guide);
              if (!inters.length) {
                return null;
              }
              var res = inters[0];
              var dst = hitResult.point.getDistance(res.point);
              for (var i = 1; i < inters.length; ++i) {
                var dst2 = hitResult.point.getDistance(inters[i].point);
                if (dst2 < dst) {
                  res = inters[i];
                  dst = dst2;
                }
              }
              return res.point;
            };

            if (numGuides == 1) {
              // If there is only one guide snap to it
              if (hitResult) {
                // If there is also an element and a guide, snap to their intersection
                if (guideHor) {
                  measurePoint = getIntersection(
                    hitResult.item,
                    guideHor.item,
                    hitResult
                  );
                  if (
                    !measurePoint ||
                    measurePoint.getDistance(point) > tolerance
                  ) {
                    measurePoint = new paper.Point(
                      hitResult.point.x,
                      guideHor.point.y
                    );
                  }
                } else {
                  measurePoint = getIntersection(
                    hitResult.item,
                    guideVer.item,
                    hitResult
                  );
                  if (
                    !measurePoint ||
                    measurePoint.getDistance(point) > tolerance
                  ) {
                    measurePoint = new paper.Point(
                      guideVer.point.x,
                      hitResult.point.y
                    );
                  }
                }
              } else {
                measurePoint = guides[0].point.clone();
              }
            } else {
              if (hitResult) {
                // Snap to the intersection closest to the mouse pointer among the
                // intersections between the guides and each guide with the element

                measurePoint = new paper.Point(
                  guideVer.item.bounds.x,
                  guideHor.item.bounds.y
                );
                var dist = measurePoint.getDistance(point, true);
                var point0 = new paper.Point(
                  guideVer.item.bounds.x,
                  hitResult.item.bounds.y
                );
                var dist0 = point0.getDistance(point, true);
                if (dist > dist0) {
                  dist = dist0;
                  measurePoint = point0;
                }
                point0 = new paper.Point(
                  hitResult.item.bounds.x,
                  guideHor.item.bounds.y
                );
                dist0 = point0.getDistance(point, true);
                if (dist > dist0) {
                  dist = dist0;
                  measurePoint = point0;
                }
              } else {
                // Only guides, snap on their intersection
                measurePoint = new paper.Point(
                  guideVer.item.bounds.x,
                  guideHor.item.bounds.y
                );
              }
            }
          }
        } else {
          if (activeLayer.bounds.contains(point)) {
            measurePoint = point.clone();
          }
        }
        updateMeasureSign();
      } else {
        hitResult = activeLayer.hitTest(point, options);
      }

      if (hitResult) {
        item = hitResult.item;

        if (item._lasercut_shape) {
          return item;
        }
        if (item.parent._lasercut_shape) {
          return item.parent;
        }
      }
      return null;
    };

    var getHitIssue = function (point, tolerance) {
      var scaled_tolerance = tolerance * paper.view.zoom;
      var options = {
        stroke: true,
        fill: true,
        tolerance: scaled_tolerance,
      };
      options["class"] = paper.Path;
      hitResult = issuesLayer.hitTest(point, options);
      if (hitResult) {
        var parent = hitResult.item.parent;
        if (parent) {
          if (parent.className == "Group") {
            return parent;
          }
        }
      }
      return null;
    };

    pan = false;
    hoverItem = null;
    var touchStart = null;
    var addPoint = true;

    tool.onMouseDown = function (e) {
      touchStart = null;
      addPoint = true;
      if (isLegendModeEnabled && e.event.button === 0) {
        if (selectionRect) {
          selectionRect.remove();
          selectionRect = null;
        }

        var modified = false;
        // Handle individual clicks
        if (!e.event.ctrlKey && !e.event.metaKey) {
          for (var i = 0; i < selectionSet.length; i++) {
            removeElemFromSelection(selectionSet[i]);
            modified = true;
          }

          selectionSet = [];
        }

        var item = hoverItem;
        if (item) {
          selectionSet.push(item._lasercut_shape);
          SvgViewer.toggleSelection(item._lasercut_shape);
        }
        if (modified) {
          updateAfterSelectionChange();
        }

        $(".viewer-toolbar-message").text($("#dragToSelectMessage").text());
        $(".viewer-toolbar-message").show();

        selectionRect = new paper.Path.Rectangle(e.point.x, e.point.y, 0, 0);
        uiLayer.addChild(selectionRect);
        selectionRect.strokeScaling = false;
        selectionRect.opacity = 0.3;
      } else if (
        e.event.type == "touchstart" ||
        e.event.button == 0 ||
        e.event.button == 1
      ) {
        if (!isMeasuringModeEnabled) {
          pan = true;
        } else if (e.event.type == "touchstart") {
          if (e.event.touches.length > 1) {
            pan = true;
          } else {
            pan = false;
          }
        } else {
          pan = true;
          touchStart = new paper.Point(e.event.clientX, e.event.clientY);
        }

        if (e.event.type == "touchstart") {
          if (isLegendModeEnabled || isScaleCheckModeEnabled) {
            if (touchEventSelected) {
              selectShape(touchEventSelected._lasercut_shape, false);
              touchEventSelected = null;
            }

            var tolerance = isMeasuringModeEnabled ? 3 : 10;
            var hitPoint = e.point.clone();
            if (isMeasuringModeEnabled) {
              hitPoint = hitPoint.subtract(0, 30 / paper.view.zoom);
              tolerance = 6;
            }

            touchEventSelected = getHitItem(hitPoint, tolerance);
            if (touchEventSelected) {
              selectShape(touchEventSelected._lasercut_shape, true);
            }
          }
          if (isShowIssuesModeEnabled) {
            if (touchEventSelected) {
              selectShape(touchEventSelected._lasercut_shape, false);
              touchEventSelected = null;
            }

            tolerance = 10;
            hitPoint = e.point.clone();
            touchEventSelected = getHitIssue(hitPoint, tolerance);
            if (touchEventSelected) {
              selectShape(touchEventSelected._lasercut_shape, true);
            }
          }
        }
      }
    };

    tool.onMouseMove = function (e) {
      if (
        !pan &&
        !selectionRect &&
        (isLegendModeEnabled ||
          isScaleCheckModeEnabled ||
          isMeasuringModeEnabled)
      ) {
        var tolerance = isMeasuringModeEnabled ? 3 : 1;
        var hitPoint = e.point.clone();
        if (e.event.type == "touchmove") {
          hitPoint = hitPoint.subtract(0, 30 / paper.view.zoom);
          tolerance *= 2;
        }

        var addGuideLine = function (x1, y1, x2, y2) {
          var line = new paper.Path.Line(
            new paper.Point(x1, y1),
            new paper.Point(x2, y2)
          );
          line.style.strokeColor = "blue";
          line.strokeScaling = false;
          line._lasercut_is_guide = true;
          activeLayer.addChild(line);
          return line;
        };

        var addGuideLines = function (point, lines) {
          var display_lines = e.event.shiftKey || e.event.type == "touchmove";
          var tolerance = 10 / paper.view.zoom;

          if (display_lines && Math.abs(hitPoint.x - point.x) < tolerance) {
            if (!lines[0]) {
              lines[0] = addGuideLine(
                point.x,
                svgBBox.y,
                point.x,
                svgBBox.y + svgBBox.height
              );
            }
          } else {
            if (lines[0]) {
              lines[0].remove();
              lines[0] = null;
            }
          }
          if (display_lines && Math.abs(hitPoint.y - point.y) < tolerance) {
            if (!lines[1]) {
              lines[1] = addGuideLine(
                svgBBox.x,
                point.y,
                svgBBox.x + svgBBox.width,
                point.y
              );
            }
          } else {
            if (lines[1]) {
              lines[1].remove();
              lines[1] = null;
            }
          }
        };

        if (isMeasuringModeEnabled && paper.view.bounds.contains(hitPoint)) {
          if (measurePoint0) {
            addGuideLines(measurePoint0, measureShapeLines0);
          }
          if (measurePoint1) {
            addGuideLines(measurePoint1, measureShapeLines1);
          }
        }

        var item = getHitItem(hitPoint, tolerance);
        if (item) {
          if (hoverItem) {
            if (item._lasercut_id != hoverItem._lasercut_id) {
              if (selectionSet.indexOf(hoverItem._lasercut_shape) < 0) {
                selectShape(hoverItem._lasercut_shape, false);
              }
              $(
                ".legendLine[data-style-id=" +
                  hoverItem._lasercut_shape.style_id +
                  "]"
              ).removeClass("on");
            } else {
              return;
            }
          }
          hoverItem = item;
          selectShape(hoverItem._lasercut_shape, true);
          $(
            ".legendLine[data-style-id=" +
              hoverItem._lasercut_shape.style_id +
              "]"
          ).addClass("on");
          paper.view.draw();
        } else if (hoverItem) {
          if (selectionSet.indexOf(hoverItem._lasercut_shape) < 0) {
            selectShape(hoverItem._lasercut_shape, false);
            paper.view.draw();
          }
          $(
            ".legendLine[data-style-id=" +
              hoverItem._lasercut_shape.style_id +
              "]"
          ).removeClass("on");
          hoverItem = null;
        }
      } else if (isShowIssuesModeEnabled) {
        if (hoverItem && !hoverItem._lasercut_shape.selected) {
          selectShape(hoverItem._lasercut_shape, false);
          hoverItem = null;
        }
        var hit = getHitIssue(e.point, 1);
        if (hit) {
          hoverItem = hit;
          selectShape(hoverItem._lasercut_shape, true);
        }
      }
    };

    var updateSelection = function (e, currentSelection) {
      var modified = false;
      if (e.event.ctrlKey || e.event.metaKey) {
        for (var i = 0; i < currentSelection.length; i++) {
          if (selectionSet.indexOf(currentSelection[i]) == -1) {
            addElemToSelection(currentSelection[i]);
            selectionSet.push(currentSelection[i]);
          }
        }
      } else {
        var i = selectionStateTemp.length;
        while (--i >= 0) {
          selectionStateTemp[i] = false;
        }
        for (var i = 0; i < currentSelection.length; i++) {
          selectionStateTemp[currentSelection[i].id] = true;
          if (!selectionState[currentSelection[i].id]) {
            addElemToSelection(currentSelection[i]);
            modified = true;
          }
        }

        for (var i = 0; i < selectionSet.length; i++) {
          if (!selectionStateTemp[selectionSet[i].id]) {
            removeElemFromSelection(selectionSet[i]);
            modified = true;
          }
        }

        selectionSet = currentSelection;
      }
      if (modified) {
        updateAfterSelectionChange();
      }
    };

    tool.onMouseDrag = function (e) {
      if (isLegendModeEnabled && selectionRect) {
        var selected = [];
        var enclosure = true;

        var bounds = new paper.Rectangle(
          Math.min(e.downPoint.x, e.point.x),
          Math.min(e.downPoint.y, e.point.y),
          Math.abs(e.point.x - e.downPoint.x),
          Math.abs(e.point.y - e.downPoint.y)
        );

        if (e.downPoint.x > e.point.x) {
          enclosure = false;
        }

        selectionRect.remove();
        selectionRect = new paper.Path.Rectangle(bounds);
        uiLayer.addChild(selectionRect);
        selectionRect.strokeScaling = false;
        selectionRect.opacity = 0.3;

        $(".viewer-toolbar-message").show();

        var filterUserItems = function (list) {
          return list.filter(function (elem) {
            return typeof elem._lasercut_id !== "undefined";
          });
        };

        if (enclosure) {
          selectionRect.style.fillColor = "#4499ee";
          selected = activeLayer.getItems({ inside: bounds });
          selected = filterUserItems(selected);
          $(".viewer-toolbar-message").text($("#enclosedMessage").text());
        } else {
          selectionRect.style.fillColor = "#44ee99";
          var overlapped = activeLayer.getItems({ overlapping: bounds });
          selected = filterUserItems(overlapped);
          $(".viewer-toolbar-message").text($("#intersectingMessage").text());
        }

        if (!selected.length) {
          updateSelection(e, []);
          return;
        }

        // Convert the NodeList to an Array
        var selection = [];
        for (var i = selected.length - 1; i >= 0; --i) {
          if (typeof selected[i]._lasercut_id != undefined) {
            selection[selected[i]._lasercut_id] = selected[i]._lasercut_shape;
          }
        }

        var currentSelection = [];
        for (var i in selection) {
          currentSelection.push(selection[i]);
        }

        updateSelection(e, currentSelection);
      } else if (pan) {
        paper.view.center = paper.view.center.subtract(
          e.point.subtract(e.downPoint)
        );
        gridGroup.fitBounds(paper.view.bounds);
        if (touchStart) {
          var stop = new paper.Point(e.event.clientX, e.event.clientY);
          var dist = stop.subtract(touchStart).length;
          if (dist > 20) {
            touchStart = null;
            addPoint = false;
          }
        }
      } else if (isMeasuringModeEnabled) {
        tool.onMouseMove(e);
      }
    };

    var clearMeasureShapeLines = function () {
      if (measureShapeLines0[0]) {
        measureShapeLines0[0].remove();
      }
      if (measureShapeLines0[1]) {
        measureShapeLines0[1].remove();
      }
      if (measureShapeLines1[0]) {
        measureShapeLines1[0].remove();
      }
      if (measureShapeLines1[1]) {
        measureShapeLines1[1].remove();
      }
      measureShapeLines0 = [null, null];
      measureShapeLines1 = [null, null];
    };

    var clearMeasurePoints = function () {
      if (measureShape0) {
        measureShape0.remove();
      }
      if (measureShape1) {
        measureShape1.remove();
      }
      if (measureLine) {
        measureLine.remove();
      }
      measurePoint0 =
        measureShape0 =
        measurePoint1 =
        measureShape1 =
        measureLine =
          null;
      clearMeasureShapeLines();
      $(".measure_tool").removeClass("active");
      $("#path_distance").val("").prop("disabled", true);
      $("#scale_check_update").addClass("disabled");
    };

    function onMouseUpScaleCheck(e) {
      if (
        isScaleCheckModeEnabled &&
        (e.event.type == "touchend" || e.event.button == 0)
      ) {
        var tolerance = isMeasuringModeEnabled ? 3 : 1;
        var target = e.event.touches
          ? touchEventSelected
          : getHitItem(e.point, tolerance);

        if (isMeasuringModeEnabled) {
          if (touchStart) {
            var stop = new paper.Point(e.event.clientX, e.event.clientY);
            var dist = stop.subtract(touchStart).length;
            if (dist > 20) {
              return;
            }
          }
          if (!addPoint) {
            return;
          }
          clearMeasureShapeLines();
          if (measurePoint) {
            if (measurePoint1) {
              clearMeasurePoints();
            }
            if (!measurePoint0) {
              if (measurePoint) {
                measurePoint0 = measurePoint.clone();
                updateMeasureShape0();
                $(".viewer-toolbar-message").show();
                $(".viewer-toolbar-message").text($("#snapMessage").text());
              } else {
                $(".viewer-toolbar-message").hide();
              }
            } else {
              measurePoint1 = measurePoint.clone();
              updateMeasureShape1();

              measureLine = new paper.Group();

              var l = new paper.Path.Line(measurePoint0, measurePoint1);
              l.style.strokeColor = "blue";
              l.strokeScaling = false;
              l.style.strokeWidth = 3;
              measureLine.addChild(l);
              l = new paper.Path.Line(measurePoint0, measurePoint1);
              l.style.strokeColor = "white";
              l.strokeScaling = false;
              measureLine.addChild(l);
              l = new paper.PointText();
              l.fillColor = "#FFF";
              l.strokeColor = "#00F";
              l.strokeScaling = false;
              l.style.strokeWidth = 0.4;
              l.fontSize = 30;
              l.justification = "center";
              l.fontFamily = "Helvetica, Arial, sans-serif";
              measureLine.addChild(l);
              uiLayer.addChild(measureLine);
              updateMeasureLine();

              $(".measure_tool").addClass("active");
            }
          }
        } else {
          SvgViewer.clearSelection();
          if (target && typeof target._lasercut_id !== "undefined") {
            selectionSet = [target._lasercut_shape];
            var bbox = configModel.elemsBBox[target._lasercut_id];

            var width = bbox.width * scale;
            var height = bbox.height * scale;

            // Converting to current units
            width /= units[design_unit];
            height /= units[design_unit];

            width = sizeToDisplay(width);
            height = sizeToDisplay(height);
            $(".check_scale").addClass("active");
            $("#path_width")
              .val("" + width)
              .prop("disabled", false);
            $("#path_height")
              .val("" + height)
              .prop("disabled", false);
            SvgViewer.addToSelection(target._lasercut_shape);
            removeSelectedBBox();
            addSelectedBBox();
          } else {
            $(".check_scale").removeClass("active");
            $("#path_width").val("").prop("disabled", true);
            $("#path_height").val("").prop("disabled", true);
            $("#scale_check_update").addClass("disabled");
            removeSelectedBBox();
          }
        }
      }
      if (isShowIssuesModeEnabled) {
        tolerance = 1;
        target = e.event.touches
          ? touchEventSelected
          : getHitIssue(e.point, tolerance);
        SvgViewer.clearSelection();
        if (target) {
          SvgViewer.addToSelection(target._lasercut_shape);
        }
      }
    }

    tool.onMouseUp = function (e) {
      killSelection(e);
      onMouseUpScaleCheck(e);
      pan = false;
    };

    $(".measure_tool .scale-field").on("input", function () {
      var clean = function (val) {
        return parseFloat(val.replace(/,/g, ".").replace(/([^0-9\.])/g, "")); // Strip out nonsense characters
      };
      var cleanVal = clean($(this).val());

      //$(this).val(sizeToDisplay(cleanVal));
      var oldSize = measureLine.children[0].length * scale;
      newScale = (cleanVal * scale) / oldSize;
      newScale = newScale.toFixed(11);
      if (!isNaN(newScale) && newScale != scale) {
        $("#scale_check_update").removeClass("disabled");
      } else {
        $("#scale_check_update").addClass("disabled");
      }
    });

    var doUpdateScale = function () {
      if ($("#scale_check_update").hasClass("disabled")) {
        return;
      }
      if (SvgViewer.on_scale_update) {
        SvgViewer.on_scale_update(newScale);
      }
      $("#scale_check_update").addClass("disabled");
    };

    $(".measure_tool .scale-field").on("change", function () {
      doUpdateScale();
    });

    $(".check_scale .scale-field").on("change", function () {
      if (selectionSet.length != 1) {
        return;
      }

      var clean = function (val) {
        return parseFloat(val.replace(/,/g, ".").replace(/([^0-9\.])/g, "")); // Strip out nonsense characters
      };
      var cleanVal = clean($(this).val());

      //cleanVal = Utils.decimalPrecision(_design, cleanVal);
      $(this).val(sizeToDisplay(cleanVal));

      var bbox = configModel.elemsBBox[selectionSet[0].id];
      var oldSize = $(this).attr("name") == "x" ? bbox.width : bbox.height;
      oldSize *= scale;
      newScale = (cleanVal * units[design_unit]) / oldSize;
      newScale = newScale * scale;

      if (!isNaN(newScale)) {
        var other = $(this).attr("name") == "x" ? "y" : "x";
        var otherElem = $(".check_scale .scale-field[name='" + other + "']");
        var otherVal = $(this).attr("name") == "x" ? bbox.height : bbox.width;
        otherVal /= units[design_unit];
        otherVal *= newScale;
        otherVal = sizeToDisplay(otherVal);
        otherElem.val(otherVal);
        $("#scale_check_update").removeClass("disabled");
      } else {
        $("#scale_check_update").addClass("disabled");
      }

      newScale /= units[design_unit];
      newScale = newScale.toFixed(11);
    });

    $("#scale_check_update").click(function () {
      doUpdateScale();
    });

    document.addEventListener("mouseup", killSelection);

    document.addEventListener("keyup", function (e) {
      if (e.keyCode == 27) {
        for (var i = 0; i < configModel.elems.length; i++) {
          if (configModel.elems[i].selected) {
            removeElemFromSelection(configModel.elems[i]);
          }
        }
        updateAfterSelectionChange();

        selectionSet = [];

        clearMeasurePoints();
      }
    });

    $("#legendContinue").on("click", function (event) {
      if ($(this).hasClass("disabled")) {
        return;
      }
      event.preventDefault();
      svgModified = true;
      SvgViewer.save(true);
    });

    $("#legendReset").on("click", function (event) {
      event.preventDefault();
      svgModified = true;
      if (SvgViewer.on_legend_reset) {
        SvgViewer.on_legend_reset(function () {
          $("#addToLegendGroup")
            .find("option")
            .not(":first")
            .not(":last")
            .remove();
        });
      }
    });

    function killSelection(e) {
      if (e.button === 0) {
        if (selectionRect) {
          selectionRect.remove();
          selectionRect = null;
        }
        if (!isMeasuringModeEnabled) {
          $(".viewer-toolbar-message").hide();
        }
      }
    }

    updateLegendMode(isLegendModeEnabled);
    if (isLegendModeEnabled) {
      addModelDimensions();
    }
    updatePosition();

    isLoaded = true;

    if (SvgViewer.on_viewer_initialized) {
      SvgViewer.on_viewer_initialized();
    }

    //resize paper view
    //prevent the viewer to stretch
    $(window).resize(function () {
      var $vierwer2dpaper = $("#viewer2dpaper");
      var $viewer2d = $("#viewer2d");

      $viewer2d.width($vierwer2dpaper.width());
      $viewer2d.height($vierwer2dpaper.height());

      SvgViewer.reset_model_position();

      paper.view.setViewSize($vierwer2dpaper.width(), $vierwer2dpaper.height());
    });
  };

  /*************************************************/
  /*                 PRIVATE METHODS               */
  /*************************************************/

  var loadModel = function (model, modelData, layer) {
    var pairs = [];

    modelData.lsrModel = model;
    modelData.elems = model.shapes;
    var paths = [];

    // Generate paths in peperjs and associate them with a lasercut shape
    // Also initialize pairs

    for (var i = 0; i < model.shape_count; ++i) {
      var shape = model.shapes[i];
      shape.id = i;
      shape.paths = [];

      var closedPath = false;
      for (var j = 0; j < shape.tn; ++j) {
        var ti = shape.ti + j;
        if (model.paths[ti].flags & 1) {
          closedPath = true;
          break;
        }
      }

      // If this is a closed path, use a compound path to avoid bad rendering
      if (closedPath) {
        var cp = new paper.CompoundPath();
      }

      for (var j = 0; j < shape.tn; ++j) {
        var ti = shape.ti + j;
        if (model.paths[ti].pn <= 1) {
          continue;
        }

        var p = new paper.Path();

        if (closedPath) {
          cp.addChild(p);
        } else {
          shape.paths.push(p);
          paths.push(p);
          p._lasercut_shape = shape;
          p._lasercut_id = p._lasercut_shape.id;
        }
        var segments = [];
        var lastSegment = null;
        for (var k = 0; k < model.paths[ti].pn; ++k) {
          var pi = model.paths[ti].pi + k;
          if (model.points[pi].flags === 2) {
            var handle1 = new paper.Point(
              model.points[pi].x,
              model.points[pi].y
            );
            var handle2 = new paper.Point(
              model.points[pi + 1].x,
              model.points[pi + 1].y
            );
            var to = new paper.Point(
              model.points[pi + 2].x,
              model.points[pi + 2].y
            );
            lastSegment.setHandleOut(handle1.subtract(lastSegment._point));

            lastSegment = new paper.Segment(to, handle2.subtract(to));
            segments.push(lastSegment);

            k += 2;
          } else {
            lastSegment = new paper.Segment(
              new paper.Point(model.points[pi].x, model.points[pi].y)
            );
            segments.push(lastSegment);
          }
        }
        p.addSegments(segments);
        if (model.paths[ti].flags & 1) {
          p.closePath();
        }
        p._lasercut_bounds = p.getBounds();
      }

      if (closedPath && cp.children.length === 0) {
        continue;
      }

      if (closedPath) {
        shape.paths.push(cp);
        paths.push(cp);
        cp._lasercut_shape = shape;
        cp._lasercut_id = cp._lasercut_shape.id;
        cp._lasercut_bounds = cp.getBounds();
      }

      var id = i;
      selectionState[id] = false;
      selectionStateTemp[id] = false;

      var set_stroke_type = shape.stroke_type;
      var set_fill_type = shape.fill_type;

      var pair = {
        strokeCutType: 5,
        strokeColor: null,
        fillCutType: 5,
        fillColor: null,
        elems: [shape],
        line_width: shape.line_width,
      };

      var curStroke = shape.stroke
        ? new paper.Color(
            shape.stroke.r / 255,
            shape.stroke.g / 255,
            shape.stroke.b / 255,
            shape.stroke.a / 255
          ).toCSS(true)
        : "none";
      var curFill = shape.fill
        ? new paper.Color(
            shape.fill.r / 255,
            shape.fill.g / 255,
            shape.fill.b / 255,
            shape.fill.a / 255
          ).toCSS(true)
        : "none";

      if (!array_includes(unsupportedColors, curFill) || set_fill_type) {
        pair.fillCutType = set_fill_type || 2;
        pair.fillCutType = parseInt(pair.fillCutType);
        if (pair.fillCutType == 0) {
          pair.fillCutType = 5;
        }
        if (pair.fillCutType == 5) {
          pair.fillColor = "none";
        } else {
          if (curFill == "none") {
            pair.fillColor = getColor(intToCutType[pair.fillCutType]);
          } else {
            pair.fillColor = curFill;
          }
        }
      }

      if (!array_includes(unsupportedColors, curStroke) || set_stroke_type) {
        pair.strokeCutType = set_stroke_type || 1;
        pair.strokeCutType = parseInt(pair.strokeCutType);
        if (pair.strokeCutType == 0) {
          pair.strokeCutType = 5;
        }
        if (pair.strokeCutType == 5) {
          pair.strokeColor = "none";
        } else {
          if (curStroke == "none") {
            pair.strokeColor = getColor(intToCutType[pair.strokeCutType]);
          } else {
            pair.strokeColor = curStroke;
          }
        }
      }

      pair.slug =
        pair.fillCutType +
        pair.fillColor +
        pair.strokeCutType +
        pair.strokeColor;

      pairs.push(pair);
    }

    layer.addChildren(paths);

    // The next piece of code creates a group octree for the paths in the object
    // This is needed to optimize hit calculation in paperjs because otherwise they check all nodes
    modelData.group_array = [];
    var children_max = Math.max(paths.length / 50, 50);
    var group_size = 2;
    var max_depth = 2;
    var createOptimGroups = function (parent, bounds, path_list, depth) {
      var sizex = bounds.width / group_size;
      var sizey = bounds.height / group_size;
      var blist = [];
      var children = [];
      for (var j = 0; j < group_size; ++j) {
        for (var k = 0; k < group_size; ++k) {
          blist.push(
            new paper.Rectangle(
              bounds.x + j * sizex,
              bounds.y + k * sizey,
              sizex,
              sizey
            ).expand(0.1)
          );
          children.push([]);
        }
      }
      for (var i = path_list.length - 1; i >= 0; --i) {
        var elem = path_list[i];
        for (var j = 0; j < group_size * group_size; ++j) {
          if (
            blist[j].contains(elem._lasercut_bounds) ||
            elem._lasercut_bounds.intersects(blist[j])
          ) {
            children[j].push(elem);
            break;
          }
        }
      }
      for (var j = 0; j < group_size * group_size; ++j) {
        if (children[j].length) {
          var group = new paper.Group();
          parent.addChild(group);
          if (depth === max_depth || children[j].length < children_max) {
            group.addChildren(children[j]);
            modelData.group_array.push(group);
            group._lasercut_styles = [];
          } else {
            createOptimGroups(group, blist[j], children[j], depth + 1);
          }
        }
      }
    };

    createOptimGroups(layer, layer.bounds, paths, 1);

    // Find unique pairs to have our separate styles
    var uniquePairs = [pairs[0]];
    for (var i = 1; i < pairs.length; i++) {
      var shouldBeAdded = true;
      for (var j = 0; j < uniquePairs.length; j++) {
        if (pairs[i].slug === uniquePairs[j].slug) {
          shouldBeAdded = false;
          uniquePairs[j].elems = uniquePairs[j].elems.concat(pairs[i].elems);
          break;
        }
      }

      if (shouldBeAdded) {
        uniquePairs.push(pairs[i]);
      }
    }

    return uniquePairs;
  };

  var loadRenderModel = function (model) {
    var tmpLayer = null;
    if (activeLayer == renderLayer) {
      tmpLayer = new paper.Layer();
      tmpLayer.visible = false;
      paper.project.insertLayer(renderLayer.index, tmpLayer);
    }
    renderModel = {
      group_array: [],
      elems: [],
      lsrModel: null,
      elemsBBox: [],
      cutTypes: null,
    };

    var uniquePairs;
    if (tmpLayer) {
      uniquePairs = loadModel(model, renderModel, tmpLayer);
    } else {
      renderLayer.removeChildren();
      uniquePairs = loadModel(model, renderModel, renderLayer);
    }
    renderModel.cutTypes = [];
    for (var i = 0; i < uniquePairs.length; i++) {
      groupPathsByStyle(renderModel, i, uniquePairs[i]);
      renderModel.cutTypes[i] = {
        stroke: uniquePairs[i].strokeCutType,
        fill: uniquePairs[i].fillCutType,
        stroke_color: uniquePairs[i].strokeColor,
        fill_color: uniquePairs[i].fillColor,
      };
    }

    if (tmpLayer) {
      activeLayer = tmpLayer;
      tmpLayer.visible = true;
      renderLayer.visible = false;
      renderLayer.remove();
      renderLayer = tmpLayer;
    } else if (!isLegendModeEnabled && enableRenderLayer) {
      configLayer.visible = false;
      renderLayer.visible = true;
      activeLayer = renderLayer;
      activeModel = renderModel;
      updateElementsMaterial(true);
    }
  };

  var selectShape = function (shape, select) {
    // Use selected instead of changing the parent in order to avoid bounds recalulation
    if (select) {
      for (var j = shape.paths.length - 1; j >= 0; --j) {
        var path = shape.paths[j];
        path.selected = select;

        if (
          path.style.strokeColor &&
          !(
            path.style.strokeColor.red == 1 &&
            path.style.strokeColor.green == 1 &&
            path.style.strokeColor.blue == 1
          )
        ) {
          path.selectedColor = path.style.strokeColor;
        } else {
          path.selectedColor = "#4499ee";
        }
        path.selectedShadowColor = path.selectedColor;
        //path.selectedShadowBlur = 5;
        if (path.style.strokeScaling) {
          path.selectedStrokeScaling = true;
          path.selectedStrokeWidth = path.style.strokeWidth * 1.2;
          if (path.selectedStrokeWidth < svgDim * 2) {
            path.selectedStrokeWidth = svgDim * 2;
          }
        } else {
          path.selectedStrokeScaling = false;
          path.selectedStrokeWidth = 2;
        }
      }
    } else {
      for (var j = shape.paths.length - 1; j >= 0; --j) {
        var path = shape.paths[j];
        path.selected = select;
      }
    }
  };

  var sizeToDisplay = function (size) {
    if (design_unit == "mm") {
      size = size.toFixed(1);
    } else {
      size = size.toFixed(2);
    }
    size = "" + size;
    size = size.replace(/0+$/gm, "");
    if (size.charAt(size.length - 1) == ".") {
      size = size.slice(0, -1);
    }
    return size;
  };

  /**
   * Provided the old and new pan values, will force the dispalyed svg to remain within the viewer
   * @param {Object} oldPan - The pan paramaters before user dragged svg
   * @param {Object} newPan - The new pan the user is requesting (through mousemove)
   * @returns {Object} customPan - The custom pan which clamps the panning to within the viewer
   */
  var keepVisible = function (oldPan, newPan) {
    var gutterWidth = 100,
      gutterHeight = 100,
      // Computed variables
      sizes = this.getSizes(),
      leftLimit =
        -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) +
        gutterWidth,
      rightLimit = sizes.width - gutterWidth - sizes.viewBox.x * sizes.realZoom,
      topLimit =
        -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) +
        gutterHeight,
      bottomLimit =
        sizes.height - gutterHeight - sizes.viewBox.y * sizes.realZoom;
    var customPan = {};

    customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
    customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));

    return customPan;
  };

  /**
   * Generates a random color with an R, G and B value that are generally on the extreme ranges to
   * ensure bright colors
   * @returns {string} colorString - The color represented as an rgb color string
   */
  var randomColor = function () {
    var colorString = "rgb(";
    var r, g, b;

    r =
      Math.random() > 0.5
        ? 120 + Math.floor(Math.random() * 120)
        : 120 - Math.floor(Math.random() * 120);
    g =
      Math.random() > 0.5
        ? 120 + Math.floor(Math.random() * 120)
        : 120 - Math.floor(Math.random() * 120);
    b =
      Math.random() > 0.5
        ? 120 + Math.floor(Math.random() * 120)
        : 120 - Math.floor(Math.random() * 120);
    colorString += r + ", " + g + ", " + b + ")";

    return colorString;
  };

  var getColor = function (cutType) {
    if (cutType === "comment") {
      return null;
    }

    var colors = getUsedColors();

    // Try to find a color that is not used yet.
    for (var i = 0; i < cutTypeColors[cutType].length; i++) {
      if (!array_includes(colors, hexToRgb(cutTypeColors[cutType][i]))) {
        return cutTypeColors[cutType][i];
      }
    }

    // No colors left. Just choose a random one for now.
    return randomColor();
  };

  // In some *rare* case, the user can add something to linear engrave, then put it in cut, and try to add another linear engrave. So,
  // we keep some colors in stock.
  var cutTypeColors = {
    cut: [
      "#E83000",
      "#BA0900",
      "#FF6832",
      "#E20027",
      "#FF4A46",
      "#FF34FF",
      "#FF2F80",
      "#CC0744",
      "#FF913F",
      "#FC009C",
    ],
    "linear-engrave": [
      "#7A4900",
      "#004D43",
      "#5A0007",
      "#A30059",
      "#D16100",
      "#7900D7",
      "#6B002C",
      "#922329",
      "#953F00",
      "#3A3F00",
    ],
    engrave: [
      "#008941",
      "#4FC601",
      "#A4E804",
      "#98D058",
      "#00B433",
      "#5EFF03",
      "#1BE177",
      "#00FECF",
      "#15A08A",
      "#00846F",
    ],
    "deep-engrave": [
      "#0045D2",
      "#006FA6",
      "#0000A6",
      "#3B5DFF",
      "#0089A3",
      "#0060CD",
      "#00C6C8",
      "#00A6AA",
      "#2F5D9B",
      "#252F99",
    ],
  };

  var cutTypeToInt = {
    cut: 1,
    engrave: 2,
    "linear-engrave": 3,
    "deep-engrave": 4,
    comment: 5,
  };

  var intToCutType = {
    1: "cut",
    2: "engrave",
    3: "linear-engrave",
    4: "deep-engrave",
    5: "comment",
  };

  var cutTypeAllowed = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
  };

  /**
   * For given element, finds the associated cut types (stroke and fill)
   */
  var getCutType = function (elem) {
    return getStyleCutType(elem._lasercut_style_id);
  };

  var getStyleCutType = function (style_id) {
    var $legendLine = $(".legendLine[data-style-id=" + style_id + "]");

    return {
      stroke: parseInt($legendLine.find("select:first").val(), 10),
      fill: parseInt($legendLine.find("select:last").val(), 10),
      stroke_color: $legendLine.data("stroke-color"),
      fill_color: $legendLine.data("fill-color"),
    };
  };

  /**
   * Get all used colors in legend.
   */
  var getUsedColors = function () {
    colors = [];

    $(".legendName .legendChip").each(function (i, el) {
      var fillColor = window.getComputedStyle(el).backgroundColor;
      var strokeColor = window.getComputedStyle(el).borderColor;

      if (!array_includes(colors, fillColor)) {
        colors.push(fillColor);
      }
      if (!array_includes(colors, strokeColor)) {
        colors.push(strokeColor);
      }
    });

    return colors;
  };

  var getLegend = function () {
    var legend = [];
    var hasSomethingToBeCut = false;
    var hasNotAllowed = false;

    var strokeCutTypes = {};
    var fillCutTypes = {};
    $(".legendLine").each(function (index, elem) {
      strokeCutTypes[$(elem).data("style-id")] = parseInt(
        $(elem).find("select:first").val()
      );
      fillCutTypes[$(elem).data("style-id")] = parseInt(
        $(elem).find("select:last").val()
      );
    });

    var cutTypes = getCutTypes();

    var typeCount = 0;
    for (var i in cutTypes) {
      cutTypes[i].elems = [];
      typeCount++;
    }

    for (var i = 0; i < configModel.elems.length; i++) {
      var style_id = configModel.elems[i].style_id;
      if (style_id) {
        cutTypes[style_id].elems.push(configModel.elems[i].id);
      }
    }

    legend.push("V3");
    legend.push(4);
    for (var i = 1; i < 5; ++i) {
      legend.push(cutTypeAllowed[i] ? "1" : "0");
    }
    legend.push(typeCount);
    for (var i in cutTypes) {
      var cut = cutTypes[i];
      legend.push(
        [
          cut.stroke,
          cut.stroke !== 5 ? rgbToHex(cut.stroke_color) : "none",
          cut.fill,
          cut.fill !== 5 ? rgbToHex(cut.fill_color) : "none",
        ].join(";")
      );

      legend.push(cut.elems.length);
      legend.push(cut.elems.join(";"));

      if (
        (cut.stroke !== 0 && cut.stroke !== 5 && cutTypeAllowed[cut.stroke]) ||
        (cut.fill !== 0 && cut.fill !== 5 && cutTypeAllowed[cut.fill])
      ) {
        hasSomethingToBeCut = true;
      }
      if (!cutTypeAllowed[cut.stroke] || !cutTypeAllowed[cut.fill]) {
        hasNotAllowed = true;
      }
    }

    return hasSomethingToBeCut ? legend.join(";") : hasNotAllowed ? -1 : null;
  };

  var groupPathsByStyle = function (model, style_id, pair) {
    // Paths in each group node are separated in a CompoundPath for each style
    // There is also a CompoundPath for each selected style
    // This is needed because the internal selection feature of paperjs draws the selected elements twice

    for (var i = 0; i < model.group_array.length; ++i) {
      var group = model.group_array[i];

      var cp = new paper.Group();
      cp.addChild(new paper.CompoundPath());
      group.addChild(cp);
      cp._lasercut_style_id = style_id;
      group._lasercut_styles[style_id] = cp;
    }

    // Put the paths of each element in the corresponding CompoundPath
    for (var i = 0; i < pair.elems.length; i++) {
      var elem = pair.elems[i];
      elem.style_id = style_id;
      for (var j = 0; j < elem.paths.length; ++j) {
        var parent = elem.paths[j].parent;
        while (!parent._lasercut_styles) {
          parent = parent.parent;
        }
        if (elem.paths[j].className == "Path") {
          parent._lasercut_styles[style_id].children[0].addChild(elem.paths[j]);
        } else {
          parent._lasercut_styles[style_id].addChild(elem.paths[j]);
        }
      }
    }

    for (var i = 0; i < model.group_array.length; ++i) {
      var group = model.group_array[i];
      var cp = group._lasercut_styles[style_id];
      cp.style.strokeColor = pair.strokeColor;
      cp.style.fillColor = pair.fillColor;
      cp._lasercut_strokeWidth = pair.line_width;

      if (pair.strokeCutType == 1 || pair.strokeCutType == 3) {
        cp.strokeScaling = false;
        cp.style.strokeWidth = 1;
      } else {
        cp.strokeScaling = true;
        cp.style.strokeWidth = cp._lasercut_strokeWidth;
      }

      cp._lasercut_stroke = cp.style.strokeColor
        ? cp.style.strokeColor.clone()
        : null;
      cp._lasercut_fill = cp.style.fillColor
        ? cp.style.fillColor.clone()
        : null;
    }
  };

  /**
   * Creates a new legend line
   * @param {Object} pair - The line configuration. Must contain fillCutType (int), fillColor, strokeCutType (int), strokeColor and elems
   */
  var createLegendLine = function (pair) {
    var nums = $.map($(".legendLine"), function (el) {
      return parseInt($(el).data("style-id"), 10);
    });
    var num = nums.length ? Math.max.apply(null, nums) + 1 : 1;

    groupPathsByStyle(configModel, num, pair);

    // Creating legend line
    var htmlString = '<li class="legendLine" data-style-id="' + num + '">';
    htmlString += '<div class="legendName clearfix">';
    htmlString += '<span class="legendChip pointer" style="background-color:';
    htmlString +=
      !pair.fillColor || pair.fillColor == "none"
        ? "transparent"
        : pair.fillColor;
    htmlString += "; border-width: 2px; border-style: solid; border-color: ";
    htmlString +=
      !pair.strokeColor || pair.strokeColor == "none"
        ? "transparent"
        : pair.strokeColor;
    htmlString += '"></span>';
    htmlString += '<div class="legend-name-text">';
    htmlString += gettext("Style") + " " + num + "";
    htmlString += '</div><div class="legend-count"></div></div>';

    // Create selects by copying the examples ones. See lasercut_legend_setter_widget.html
    htmlString += '<div class="clearfix"><div>' + gettext("Outline") + "</div>";
    htmlString += $("<div/>")
      .append(
        $("#legendOutlineSelector")
          .clone()
          .removeClass("hidden")
          .attr("id", null)
      )
      .html();
    htmlString += "</div>";
    htmlString +=
      '<div class="clearfix m4t"><div>' + gettext("Fill") + "</div>";
    htmlString += $("<div/>")
      .append(
        $("#legendFillSelector").clone().removeClass("hidden").attr("id", null)
      )
      .html();
    htmlString += "</div>";
    htmlString += "</li>";

    $html = $(htmlString);
    $html.find("select:first").val(pair.strokeCutType);
    $html.find("select:last").val(pair.fillCutType);

    $html.data("fill-color", pair.fillColor);
    $html.data("stroke-color", pair.strokeColor);

    $(".colorLegend").append($html);

    // Adding an option in the "addTo" selector
    var option =
      '<option value="' +
      num +
      '">' +
      gettext("Style") +
      " " +
      num +
      "</option>";
    $(option).insertBefore($("#addToLegendGroup").find("option:last"));

    // Change colors when changing option
    $html.find("select").change(function (event) {
      var cssType = $(event.currentTarget).data("style-type");
      var elemType = $(event.currentTarget).data("attr");

      var cutType = parseInt($(event.currentTarget).val(), 10);
      // Get a color
      var color = cutType ? getColor(intToCutType[cutType]) : null;

      // Change paths matching current style colors
      var cutTypes = getCutTypes();
      for (var i = 0; i < configModel.group_array.length; ++i) {
        var cut = cutTypes[num];
        var stroke_visible =
          cutTypeAllowed[cut.stroke] && !(cut.stroke == 0 || cut.stroke == 5);
        var fill_visible =
          cutTypeAllowed[cut.fill] && !(cut.fill == 0 || cut.fill == 5);
        var elem = configModel.group_array[i]._lasercut_styles[num];
        if (elemType === "stroke") {
          if (color) {
            if (stroke_visible) {
              elem.style.strokeColor = color;
            } else if (fill_visible) {
              elem.style.strokeColor = null;
            } else {
              elem.style.strokeColor = "white";
            }
            elem._lasercut_stroke = new paper.Color(color);
          } else {
            if (elem._lasercut_fill == null) {
              elem.style.strokeColor = "white";
            } else {
              elem.style.strokeColor = null;
            }
            elem._lasercut_stroke = null;
          }
          elem.strokeScaling = !!(cutType == 2 || cutType == 4);
          elem.style.strokeWidth = elem.strokeScaling
            ? elem._lasercut_strokeWidth
            : 1;
        } else {
          if (fill_visible) {
            elem.style.fillColor = color;
          } else {
            elem.style.fillColor = null;
          }

          if (color) {
            elem._lasercut_fill = new paper.Color(color);
            if (!stroke_visible) {
              elem.style.strokeColor = null;
            }
          } else {
            elem._lasercut_fill = null;
            if (!stroke_visible) {
              elem.style.strokeColor = "white";
            }
          }
        }
        var bboxset = [];
        var list = elem.children;
        var all_list = [];
        for (var j = list.length - 1; j >= 0; --j) {
          var child = list[j];
          if (child._lasercut_shape) {
            all_list.push(child);
          } else {
            all_list = all_list.concat(child.children);
          }
        }
        list = all_list;

        for (var j = list.length - 1; j >= 0; --j) {
          var child = list[j];
          if (!child._lasercut_shape || bboxset[child._lasercut_id]) {
            continue;
          }
          bboxset[child._lasercut_id] = true;
          if (child._lasercut_shape.selected) {
            selectShape(child._lasercut_shape, true);
          }
          if (!stroke_visible && !fill_visible) {
            configModel.elemsBBox[child._lasercut_id] = null;
          } else if (stroke_visible && (cut.stroke == 2 || cut.stroke == 4)) {
            configModel.elemsBBox[child._lasercut_id] = boundsToBBox(
              getShapeStrokeBounds(child._lasercut_shape)
            );
          } else {
            configModel.elemsBBox[child._lasercut_id] = boundsToBBox(
              getShapeBounds(child._lasercut_shape)
            );
          }
        }
      }

      updateSVGBBox();

      color = cutType > 0 && cutType < 5 ? color : "transparent";
      // Change chip color
      var $chip = $(event.currentTarget)
        .closest(".legendLine")
        .find(".legendName .legendChip");
      $chip.css(cssType, color);
      $chip
        .parent()
        .parent()
        .data(elemType + "-color", color);

      SvgViewer.legendUpdated();
    });

    return num;
  };

  /**
   * Converts and rgb string to its hex equivalent
   * @param {string} rgb - The rgb string to convert
   */
  var rgbToHex = function (rgb) {
    // optimize on common colors
    switch (rgb) {
      case "rgb(0, 0, 0)":
        return "000000";
      case "rgb(255, 255, 255)":
        return "ffffff";
      case "rgb(255, 0, 0)":
        return "ff0000";
      case "rgb(0, 255, 0)":
        return "00ff00";
      case "rgb(0, 0, 255)":
        return "0000ff";
      case "none":
        return "none";
      default:
        if (rgb[0] === "r") {
          rgb = rgb.match(
            /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
          );

          return rgb && rgb.length === 4
            ? ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
            : "";
        } else {
          return rgb.substring(1);
        }
    }
  };

  var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? "rgb(" +
          [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
          ].join(", ") +
          ")"
      : null;
  };

  var updateBackgroundTexture = function () {
    if (!isLoaded || !materialBackground) {
      return;
    }
    if (backgroundLoading) {
      return;
    }
    backgroundLoading = true;
    if (backgroundGroup) {
      backgroundGroup.remove();
      backgroundGroup = null;
    }

    //limite the scale to avoid stack issue with paper.js and big texture
    //right now ( 2017 ) the maximum size of the scale for a thing than we can lasercut is 37 x 23 in
    //with a limit of scale : 8.9504
    //30 seems plenty
    if (scale > 30) {
      scale = 30;
    }

    // Unzoom the texture tile size proportionally to the real object size (svgBBox.width * scale)
    // Limit tile size. Under a certain size, the texture is not visible anyway (+moiré)
    // and the crazy layout loop below is o n2 on the inverse of the tile size.
    // The factor was determined empirically to look natural on screen for a 1:1 displayed object
    var tile_size = Math.max(220, 28800.0 / (svgBBox.width * scale));

    var raster = new paper.Raster(materialBackground);
    raster.visible = false;
    raster.onLoad = function () {
      if (!svgBBox) {
        backgroundLoading = false;
        return;
      }
      var x = svgBBox.x + svgBBox.width / 2;
      while (x > svgBBox.x) {
        x -= tile_size;
      }
      var yt = svgBBox.y + svgBBox.height / 2;
      while (yt > svgBBox.y) {
        yt -= tile_size;
      }
      var tiles = [svgBboxOutline.clone()];
      while (x < svgBBox.x + svgBBox.width) {
        var y = yt;
        while (y < svgBBox.y + svgBBox.height) {
          var tile = raster.clone();
          tile.visible = true;
          tile.bounds = new paper.Rectangle(
            x - 0.01,
            y - 0.01,
            tile_size + 0.02,
            tile_size + 0.02
          );
          tiles.push(tile);
          y += tile_size;
        }
        x += tile_size;
      }

      raster.remove();

      backgroundGroup = new paper.Group(tiles);
      backgroundGroup.clipped = true;
      backgroundLayer.addChild(backgroundGroup);

      backgroundGroup.visible = backgroundVisible;

      backgroundLoading = false;
    };
  };

  var updateBackgroundTextureDisplay = function () {
    if (materialBackground && !isLegendModeEnabled && svgBBox) {
      backgroundVisible = true;
      if (backgroundGroup) {
        backgroundGroup.visible = true;
      } else {
        updateBackgroundTexture();
      }
    } else {
      backgroundVisible = false;
      if (backgroundGroup) {
        backgroundGroup.visible = false;
      }
    }
  };

  var removeFinalMaterial = function () {
    var cutTypes = getCutTypes(activeModel);
    for (var i = 0; i < activeModel.group_array.length; ++i) {
      for (var j in cutTypes) {
        var cutType = cutTypes[j];
        var elem = activeModel.group_array[i]._lasercut_styles[j];
        elem.strokeScaling = !!(cutType.stroke == 2 || cutType.stroke == 4);
        elem.style.strokeWidth = elem.strokeScaling
          ? elem._lasercut_strokeWidth
          : 1;
        var stroke_visible =
          cutTypeAllowed[cutType.stroke] &&
          !(cutType.stroke == 0 || cutType.stroke == 5);
        var fill_visible =
          cutTypeAllowed[cutType.fill] &&
          !(cutType.fill == 0 || cutType.fill == 5);
        if (!stroke_visible) {
          if (!fill_visible) {
            elem.style.strokeColor = "white";
          } else {
            elem.style.strokeColor = null;
          }
        } else {
          elem.style.strokeColor = elem._lasercut_stroke
            ? elem._lasercut_stroke.clone()
            : null;
        }

        if (!fill_visible) {
          elem.style.fillColor = undefined;
        } else {
          elem.style.fillColor = elem._lasercut_fill
            ? elem._lasercut_fill.clone()
            : null;
        }
      }
    }
  };

  var lastUpdateElementsMaterial = null;

  var updateElementsMaterial = function (force) {
    if (!isLoaded) {
      return;
    }
    if (!force && isLegendModeEnabled == lastUpdateElementsMaterial) {
      return;
    }
    lastUpdateElementsMaterial = isLegendModeEnabled;

    if (isLegendModeEnabled) {
      removeFinalMaterial();
    } else {
      var cutTypes = getCutTypes(activeModel);
      for (var i = 0; i < activeModel.group_array.length; ++i) {
        for (var j in cutTypes) {
          var cutType = cutTypes[j];

          var elem = activeModel.group_array[i]._lasercut_styles[j];
          var stroke = cutTypeAllowed[cutType.stroke] ? cutType.stroke : 0;
          switch (stroke) {
            case 1: {
              elem.style.strokeColor = materialCutColor;
              elem.strokeScaling = false;
              break;
            }
            case 3: {
              elem.style.strokeColor = materialLinearColor;
              elem.strokeScaling = false;
              break;
            }
            case 2: {
              elem.style.strokeColor = materialEngraveColor;
              elem.strokeScaling = true;
              break;
            }
            case 4: {
              elem.style.strokeColor = materialDeepColor;
              elem.strokeScaling = true;
              break;
            }
            default: {
              elem.style.strokeColor = undefined;
            }
          }
          elem.style.strokeWidth = elem.strokeScaling
            ? elem._lasercut_strokeWidth
            : 1;

          var fill = cutTypeAllowed[cutType.fill] ? cutType.fill : 0;
          switch (fill) {
            case 2: {
              elem.style.fillColor = materialEngraveColor;
              break;
            }
            case 4: {
              elem.style.fillColor = materialDeepColor;
              break;
            }
            default: {
              elem.style.fillColor = undefined;
            }
          }
        }
      }
    }
  };

  var updateMaterial = function (force) {
    updateBackgroundTexture();
    updateBackgroundTextureDisplay();
    updateElementsMaterial(force);
  };

  var zoomToRect = function (rect) {
    var viewBounds = paper.view.bounds.scale(paper.view.zoom);
    if (
      (isLegendModeEnabled || isShowIssuesModeEnabled) &&
      $(window).width() >= 1024
    ) {
      viewBounds.width -= 200;
    }
    var width = rect.width ? rect.width : svgDim;
    var height = rect.height ? rect.height : svgDim;

    var zoomx = viewBounds.width / width;
    var zoomy = viewBounds.height / height;

    if (zoomx && (!zoomy || zoomx < zoomy)) {
      var zoom = zoomx;
      zoom = Math.round(height * zoom) / height;
    } else {
      var zoom = zoomy;
      zoom = Math.round(width * zoom) / width;
    }

    if (isLegendModeEnabled && $(window).width() >= 1024) {
      paper.view.center = rect.center.add(-100 / zoom, 0);
    } else if (isShowIssuesModeEnabled && $(window).width() >= 1024) {
      paper.view.center = rect.center.add(100 / zoom, 0);
    } else {
      paper.view.center = rect.center;
    }

    paper.view.zoom = zoom;

    if (gridGroup) {
      gridGroup.fitBounds(paper.view.bounds);
    }
  };

  var updatePosition = function () {
    if (!svgBboxZoomHack) {
      return;
    }
    zoomToRect(svgBboxZoomHack);
  };

  var getCutTypes = function (model) {
    if (model && model.cutTypes) {
      return model.cutTypes;
    }
    var cutTypes = {};
    $(".legendLine").each(function (index, elem) {
      var id = $(elem).data("style-id");
      cutTypes[id] = getStyleCutType(id);
    });
    return cutTypes;
  };

  var updateLegendMode = function (activated) {
    isLegendModeEnabled = activated;

    for (var i = 0; i < selectionSet.length; i++) {
      var elem = selectionSet[i];
      // Remove selections
      removeElemFromSelection(elem);
    }
    selectionSet = [];
    updateAfterSelectionChange();

    if (enableRenderLayer) {
      if (isLegendModeEnabled) {
        configLayer.visible = true;
        renderLayer.visible = false;
        activeLayer = configLayer;
        activeModel = configModel;
      } else {
        configLayer.visible = false;
        renderLayer.visible = true;
        activeLayer = renderLayer;
        activeModel = renderModel;
      }
    }

    updateElementsMaterial();
    updateBackgroundTextureDisplay();
  };

  var updateScaleCheckMode = function (activated) {
    isScaleCheckModeEnabled = activated;

    $("#path_width").val("").prop("disabled", true);
    $("#path_height").val("").prop("disabled", true);
    if (configModel.elems && configModel.elems.length) {
      for (var i = 0; i < selectionSet.length; i++) {
        var elem = selectionSet[i];
        // Remove selections
        removeElemFromSelection(elem);
      }
      selectionSet = [];
      updateAfterSelectionChange();
      if (activated) {
        addModelDimensions();
      } else {
        removeModelDimensions();
      }
    }
    if (activated) {
      updatePosition();
    } else {
      removeSelectedBBox();
    }
  };

  var updateMeasuringMode = function (activated) {
    isMeasuringModeEnabled = activated;

    if (isMeasuringModeEnabled) {
      if (!isScaleCheckModeEnabled) {
        updateScaleCheckMode(true);
      }
    } else {
      if (measureSign) {
        measureSign.remove();
        measureSign = measurePoint = null;
      }
      if (measureShape0) {
        measureShape0.remove();
        measureShape0 = measurePoint0 = null;
      }
      if (measureShape1) {
        measureShape1.remove();
        measureShape1 = measurePoint1 = null;
      }
      if (measureShapeLines0[0]) {
        measureShapeLines0[0].remove();
      }
      if (measureShapeLines0[1]) {
        measureShapeLines0[1].remove();
      }
      if (measureShapeLines1[0]) {
        measureShapeLines1[0].remove();
      }
      if (measureShapeLines1[1]) {
        measureShapeLines1[1].remove();
      }
      measureShapeLines0 = [null, null];
      measureShapeLines1 = [null, null];
      if (measureLine) {
        measureLine.remove();
      }
      $(".measure_tool").removeClass("active");
      $("#path_distance").val("").prop("disabled", true);
      $("#scale_check_update").addClass("disabled");
    }

    $("#path_width").val("").prop("disabled", true);
  };

  var updateSelectedStyleOnLegend = function () {
    $(".legendLine").removeClass("active");

    var selected_ids = {};

    for (var i = 0; i < selectionSet.length; i++) {
      if (!configModel.elems[i].style_id) {
        continue;
      }
      selected_ids[selectionSet[i].style_id] = true;
    }

    for (var i in selected_ids) {
      $(".legendLine[data-style-id=" + i + "]").addClass("active");
    }

    var el = $($(".legendLine.active")[0]);

    if (!scrollAnimation && el.length) {
      var top = el.position().top + $(".colorLegend").scrollTop();
      scrollAnimation = true;
      $(".colorLegend").animate({ scrollTop: top }, 200, function () {
        scrollAnimation = false;
      });
    }
  };

  var boundsToBBox = function (bounds) {
    if (!bounds) {
      return null;
    }
    return {
      x: bounds.x,
      y: bounds.y,
      width: bounds.width,
      height: bounds.height,
    };
  };

  var getShapeBounds = function (shape) {
    if (!shape.paths.length) {
      return null;
    }
    var bounds = shape.paths[0].bounds;
    for (var i = shape.paths.length - 1; i > 0; --i) {
      bounds = bounds.unite(shape.paths[i].bounds);
    }
    return bounds;
  };

  var getShapeStrokeBounds = function (shape) {
    if (!shape.paths.length) {
      return null;
    }
    var bounds = shape.paths[0].strokeBounds;
    for (var i = shape.paths.length - 1; i > 0; --i) {
      bounds = bounds.unite(shape.paths[i].strokeBounds);
    }
    return bounds;
  };

  var createElementsBBoxList = function (model, cutTypes) {
    model.elemsBBox = [];
    for (var i = 0; i < model.elems.length; ++i) {
      var elem = model.elems[i];
      var style_id = elem.style_id;
      var bbox = null;
      if (style_id && cutTypes && cutTypes[style_id]) {
        var cutType = cutTypes[style_id];
        var stroke_visible =
          cutTypeAllowed[cutType.stroke] &&
          !(cutType.stroke === 0 || cutType.stroke === 5);
        var fill_visible =
          cutTypeAllowed[cutType.fill] &&
          !(cutType.fill === 0 || cutType.fill === 5);
        if (!stroke_visible && !fill_visible) {
          bbox = null;
        } else if (
          stroke_visible &&
          (cutType.stroke === 2 || cutType.stroke === 4)
        ) {
          bbox = getShapeStrokeBounds(elem);
        } else {
          bbox = getShapeBounds(elem);
        }
      } else {
        bbox = getShapeStrokeBounds(elem);
      }
      model.elemsBBox.push(boundsToBBox(bbox));
    }
  };

  var mergeBBox = function (bbox1, bbox2) {
    if (!bbox2) return;
    var xMin1 = bbox1.x;
    var yMin1 = bbox1.y;
    var xMax1 = xMin1 + bbox1.width;
    var yMax1 = yMin1 + bbox1.height;
    var xMin2 = bbox2.x;
    var yMin2 = bbox2.y;
    var xMax2 = xMin2 + bbox2.width;
    var yMax2 = yMin2 + bbox2.height;
    var xMin = xMin1 < xMin2 ? xMin1 : xMin2;
    var yMin = yMin1 < yMin2 ? yMin1 : yMin2;
    var xMax = xMax1 > xMax2 ? xMax1 : xMax2;
    var yMax = yMax1 > yMax2 ? yMax1 : yMax2;
    bbox1.x = xMin;
    bbox1.y = yMin;
    bbox1.width = xMax - xMin;
    bbox1.height = yMax - yMin;
    bbox1.x2 = xMax;
    bbox1.y2 = yMax;
    bbox1.cx = (xMin + xMax) / 2;
    bbox1.cy = (yMin + yMax) / 2;
  };

  var updateSVGBBox = function () {
    svgBBox = null;
    for (var i = 0; i < configModel.elemsBBox.length; ++i) {
      if (configModel.elemsBBox[i]) {
        if (svgBBox == null) {
          svgBBox = $.extend({}, configModel.elemsBBox[i]);
        } else {
          mergeBBox(svgBBox, configModel.elemsBBox[i]);
        }
      }
    }

    if (svgBBox != null) {
      svgDim = Math.max(svgBBox.width, svgBBox.height) / 200;
      if (svgQuestionmark) {
        svgQuestionmark.visible = false;
      }

      svgDim = Math.max(svgBBox.width, svgBBox.height) / 200;

      if (svgBboxOutline) {
        svgBboxOutline.bounds = new paper.Rectangle(
          svgBBox.x - svgDim * 6,
          svgBBox.y - svgDim * 6,
          svgBBox.width + svgDim * 12,
          svgBBox.height + svgDim * 12
        );
      }

      if (svgBboxZoomHack) {
        svgBboxZoomHack.x = svgBBox.x - svgDim * 10;
        svgBboxZoomHack.y = svgBBox.y - svgDim * 10;
        svgBboxZoomHack.width = svgBBox.width + svgDim * 20;
        svgBboxZoomHack.height = svgBBox.height + svgDim * 20;
      }

      updateBackgroundTexture();

      if (dimensionsGroup) {
        removeModelDimensions();
        addModelDimensions();
      } else {
        if (isLegendModeEnabled) {
          addModelDimensions();
        }
      }
    } else {
      if (svgQuestionmark) {
        svgQuestionmark.visible = true;
        zoomToRect(svgQuestionmarkBBox);
      }
      removeModelDimensions();
    }
  };

  var addLine = function (x1, y1, x2, y2) {
    var line = new paper.Path.Line(x1, y1, x2, y2);
    line.strokeScaling = false;
    line.style = {
      strokeColor: "#00F",
      strokeWidth: 1,
      dashArray: svgDim * 20,
    };
    return line;
  };

  var addModelDimensions = function () {
    if (!svgBBox) {
      return;
    }

    if (dimensionsGroup) {
      dimensionsGroup.visible = true;
    } else {
      var items = [];

      items.push(
        addLine(
          svgBBox.x,
          svgBBox.y + svgBBox.height + svgDim * 8,
          svgBBox.x,
          svgBBox.y + svgBBox.height + svgDim * 30
        )
      );
      items.push(
        addLine(
          svgBBox.x + svgBBox.width,
          svgBBox.y + svgBBox.height + svgDim * 8,
          svgBBox.x + svgBBox.width,
          svgBBox.y + svgBBox.height + svgDim * 30
        )
      );
      items.push(
        addLine(
          svgBBox.x,
          svgBBox.y + svgBBox.height + svgDim * 25,
          svgBBox.x + svgBBox.width,
          svgBBox.y + svgBBox.height + svgDim * 25
        )
      );

      dimensionsWidth = new paper.PointText();
      dimensionsWidth.fillColor = "#000";
      dimensionsWidth.translate(
        svgBBox.x + svgBBox.width / 2,
        svgBBox.y + svgBBox.height + svgDim * 22
      );
      dimensionsWidth.fontSize = 20;
      dimensionsWidth.scale(svgDim / 2);
      dimensionsWidth.justification = "center";
      dimensionsWidth.fontFamily = "Helvetica, Arial, sans-serif";
      items.push(dimensionsWidth);

      items.push(
        addLine(
          svgBBox.x + svgBBox.width + svgDim * 8,
          svgBBox.y,
          svgBBox.x + svgBBox.width + svgDim * 30,
          svgBBox.y
        )
      );
      items.push(
        addLine(
          svgBBox.x + svgBBox.width + svgDim * 8,
          svgBBox.y + svgBBox.height,
          svgBBox.x + svgBBox.width + svgDim * 30,
          svgBBox.y + svgBBox.height
        )
      );
      items.push(
        addLine(
          svgBBox.x + svgBBox.width + svgDim * 25,
          svgBBox.y,
          svgBBox.x + svgBBox.width + svgDim * 25,
          svgBBox.y + svgBBox.height
        )
      );

      dimensionsHeight = new paper.PointText();
      dimensionsHeight.fillColor = "#000";
      dimensionsHeight.matrix = dimensionsHeight.matrix
        .translate(
          svgBBox.x + svgBBox.width + svgDim * 22,
          svgBBox.y + svgBBox.height / 2
        )
        .rotate(-90);
      dimensionsHeight.fontSize = 20;
      dimensionsHeight.scale(svgDim / 2);
      dimensionsHeight.justification = "center";
      dimensionsHeight.fontFamily = "Helvetica, Arial, sans-serif";
      items.push(dimensionsHeight);

      dimensionsGroup = new paper.Group(items);
      uiLayer.addChild(dimensionsGroup);
    }
    updateModelDimensions();

    if (svgBboxZoomHack) {
      svgBboxZoomHack.width = svgBBox.width + svgDim * 45;
      svgBboxZoomHack.height = svgBBox.height + svgDim * 45;
    }
  };

  var removeModelDimensions = function () {
    if (dimensionsGroup) {
      dimensionsGroup.remove();
      dimensionsGroup = false;
    }
    if (svgBboxZoomHack && svgBBox) {
      svgBboxZoomHack.width = svgBBox.width + svgDim * 20;
      svgBboxZoomHack.height = svgBBox.height + svgDim * 20;
    }
  };

  var updateModelDimensions = function () {
    if (!svgBBox) {
      return;
    }
    if (dimensionsWidth && dimensionsHeight) {
      var width = svgBBox.width * scale;
      var height = svgBBox.height * scale;

      // Converting to current units
      width /= units[design_unit];
      height /= units[design_unit];

      dimensionsWidth.content = "" + sizeToDisplay(width) + design_unit;
      dimensionsHeight.content = "" + sizeToDisplay(height) + design_unit;
    }
  };

  var addSelectedBBox = function () {
    var i = selectionSet[0].id;

    selectedBBox = new paper.Path.Rectangle(
      configModel.elemsBBox[i].x,
      configModel.elemsBBox[i].y,
      configModel.elemsBBox[i].width,
      configModel.elemsBBox[i].height
    );
    uiLayer.addChild(selectedBBox);
    selectedBBox.strokeColor = "#0000FF";
    selectedBBox.strokeScaling = false;
    selectedBBox.dashOffset = svgDim * 5;
    selectedBBox.opacity = 0.9;
  };

  var removeSelectedBBox = function () {
    if (selectedBBox) {
      selectedBBox.remove();
      selectedBBox = null;
    }
  };

  var toggleAddToButton = function () {
    if (selectionSet.length > 0) {
      $("#addToLegendGroup").show();
      $("#addToLegendHint").hide();
    } else {
      $("#addToLegendGroup").hide();
      $("#addToLegendHint").show();
    }
  };

  var updateSelectedElementsCount = function () {
    var counts = {};
    var totals = {};
    var $lines = $(".legendLine");

    for (var i = 0; i < selectionSet.length; i++) {
      if (!selectionSet[i].style_id) {
        continue;
      }
      var styleId = selectionSet[i].style_id;

      if (!counts[styleId]) {
        counts[styleId] = 1;
      } else {
        counts[styleId] += 1;
      }
    }

    for (var i = 0; i < configModel.elems.length; i++) {
      if (!configModel.elems[i].style_id) {
        continue;
      }
      var styleId = configModel.elems[i].style_id;
      if (!totals[styleId]) {
        totals[styleId] = 1;
      } else {
        totals[styleId] += 1;
      }
    }
    for (var i = 0; i < $lines.length; i++) {
      var $line = $($lines[i]);
      var styleId = $line.data("style-id");
      if (!counts[styleId]) {
        $line.find(".legend-count").empty();
      } else {
        $line
          .find(".legend-count")
          .html(counts[styleId] + "/" + totals[styleId]);
      }
    }
  };

  var addElemToSelection = function (elem) {
    selectionState[elem.id] = true;
    elem.selected = true;
    selectShape(elem, true);
  };

  var removeElemFromSelection = function (elem) {
    selectionState[elem.id] = false;
    elem.selected = false;
    selectShape(elem, false);
  };

  var updateAfterSelectionChange = function () {
    updateSelectedStyleOnLegend();
    toggleAddToButton();
    updateSelectedElementsCount();
  };

  /*************************************************/
  /*                 PUBLIC METHODS                */
  /*************************************************/

  /**
   * Adds an element to the selection
   * @param {SvgElement} elem - The element to add to the selection
   */
  SvgViewer.addToSelection = function (elem) {
    addElemToSelection(elem);

    updateAfterSelectionChange();
  };

  /**
   * Removes an element from the selection
   * @param {SvgElement} elem - The element to remove from the selection
   */
  SvgViewer.removeFromSelection = function (elem) {
    removeElemFromSelection(elem);

    updateAfterSelectionChange();
  };

  /**
   * Clear selection
   */
  SvgViewer.clearSelection = function () {
    for (var i = 0; i < configModel.elems.length; i++) {
      removeElemFromSelection(configModel.elems[i]);
    }

    selectionSet = [];
    updateAfterSelectionChange();
  };

  /**
   * Toggles whether the element is part of the selection or not
   * @param {SvgElement} elem - The element to toggle
   */
  SvgViewer.toggleSelection = function (elem) {
    if (elem.selected) {
      SvgViewer.removeFromSelection(elem);
    } else {
      SvgViewer.addToSelection(elem);
    }
  };

  /**
   * Select elements matching the provided style idx
   * @param {Integer} styleIdx
   */
  SvgViewer.selectElementsWithStyle = function (styleIdx) {
    SvgViewer.clearSelection();

    styleIdx = parseInt(styleIdx);
    for (var i = 0; i < configModel.elems.length; i++) {
      if (configModel.elems[i].style_id === styleIdx) {
        selectionSet.push(configModel.elems[i]);
        addElemToSelection(configModel.elems[i]);
      }
    }
    updateAfterSelectionChange();
  };

  /**
   * Highlight SVG elements matching the specified color
   */
  SvgViewer.highlight = function (styleIdx) {
    if (!configModel.elems && !configModel.elems.length) return;

    styleIdx = parseInt(styleIdx);
    for (var i = 0; i < configModel.elems.length; i++) {
      if (configModel.elems[i].style_id === styleIdx) {
        configModel.elems[i].selected = true;
        selectShape(configModel.elems[i], true);
      }
    }
  };

  /**
   * Unhighlight all SVG elements
   */
  SvgViewer.unhighlight = function () {
    if (!configModel.elems && !configModel.elems.length) return;

    for (var i = 0; i < configModel.elems.length; i++) {
      if (
        configModel.elems[i].selected &&
        selectionSet.indexOf(configModel.elems[i]) < 0
      ) {
        configModel.elems[i].selected = false;
        selectShape(configModel.elems[i], false);
      }
    }
  };

  SvgViewer.setLegendMode = function (activated) {
    if (activated != isLegendModeEnabled) {
      if (isScaleCheckModeEnabled) {
        updateScaleCheckMode(false);
      }
      updateLegendMode(activated);
    }

    if (activated) {
      addModelDimensions();
      updatePosition();
    } else if (!isScaleCheckModeEnabled) {
      removeModelDimensions();
      updatePosition();
    }
  };

  SvgViewer.setRainbowMode = function () {
    materialCutColor = "red";
    materialLinearColor = "blue";
    materialEngraveColor = "black";
    materialDeepColor = "green";

    if (configModel.elems.length && configModel.elems[0].style) {
      for (var i = 0; i < configModel.elems.length; ++i) {
        var elem = configModel.elems[i];
        if (elem.name && elem.name.startsWith("printer_file_")) {
          elem.style.strokeColor = materialLinearColor;
          elem.style.strokeWidth =
            elem.name === "printer_file_logo" ? 0.5 : 0.1;
          elem.style.fillColor = null;
          elem.strokeScaling = false;
        } else if (!elem.name) {
          elem.style.strokeWidth = 1;
          elem.strokeScaling = false;
        } else {
          switch (elem._lasercut_stroke_type) {
            case 0:
            case 5:
              elem.style.strokeColor = null;
              break;
            case 1:
              elem.style.strokeColor = materialCutColor;
              elem.strokeScaling = false;
              elem.style.strokeWidth = 1;
              break;
            case 2:
              elem.style.strokeColor = materialEngraveColor;
              break;
            case 3:
              elem.style.strokeColor = materialLinearColor;
              elem.strokeScaling = false;
              elem.style.strokeWidth = 1;
              break;
            case 4:
              elem.style.strokeColor = materialDeepColor;
              break;
          }
          switch (elem._lasercut_fill_type) {
            case 0:
            case 5:
              elem.style.fillColor = null;
              break;
            case 2:
              elem.style.fillColor = materialEngraveColor;
              break;
            case 4:
              elem.style.fillColor = materialDeepColor;
              break;
          }
        }
      }
    } else {
      var colorCut = new paper.Color(255, 0, 0);
      var colorLinear = new paper.Color(0, 0, 255);
      var colorEngrave = new paper.Color(0, 0, 0);
      var colorDeep = new paper.Color(0, 255, 0);

      var cutTypes = getCutTypes(configModel);
      for (var i = 0; i < configModel.group_array.length; ++i) {
        for (var j in cutTypes) {
          var cutType = cutTypes[j];

          var elem = activeModel.group_array[i]._lasercut_styles[j];
          var stroke = cutTypeAllowed[cutType.stroke] ? cutType.stroke : 0;
          switch (stroke) {
            case 1: {
              elem.style.strokeColor = colorCut;
              elem.strokeScaling = false;
              break;
            }
            case 3: {
              elem.style.strokeColor = colorLinear;
              elem.strokeScaling = false;
              break;
            }
            case 2: {
              elem.style.strokeColor = colorEngrave;
              elem.strokeScaling = false;
              break;
            }
            case 4: {
              elem.style.strokeColor = colorDeep;
              elem.strokeScaling = false;
              break;
            }
            default: {
              elem.style.strokeColor = undefined;
            }
          }
          elem.style.strokeWidth = elem.strokeScaling
            ? elem._lasercut_strokeWidth
            : 1;

          var fill = cutTypeAllowed[cutType.fill] ? cutType.fill : 0;
          switch (fill) {
            case 2: {
              elem.style.fillColor = colorEngrave;
              break;
            }
            case 4: {
              elem.style.fillColor = colorDeep;
              break;
            }
            default: {
              elem.style.fillColor = undefined;
            }
          }
        }
      }
    }
    paper.view.draw();
  };

  SvgViewer.setScaleCheckMode = function (activated) {
    if (activated != isScaleCheckModeEnabled) {
      if (isLegendModeEnabled) {
        updateLegendMode(false);
      }
      updateScaleCheckMode(activated);
    }
  };

  SvgViewer.setMeasuringMode = function (activated) {
    if (activated != isMeasuringModeEnabled) {
      updateMeasuringMode(activated);
    }
  };

  SvgViewer.updateScale = function (s, mm_s, u, us) {
    scale = s;
    mm_scale = mm_s;
    design_unit = u;
    units = $.extend({}, us);

    // Here, the default unit is in mm, so it's easier to convert from it.
    for (var i in units) {
      if (units.hasOwnProperty(i)) {
        units[i] *= 10;
      }
    }

    // Update text in scale check
    $(".check_scale .unit").html(design_unit);
    $(".measure_tool .unit").html(design_unit);

    updateBackgroundTexture();
    updateBackgroundTextureDisplay();
    updateModelDimensions();
    updateMeasureLine();
  };

  var updateMeasureSign = function () {
    if (measureSign) {
      measureSign.remove();
      measureSign = null;
    }
    if (measurePoint) {
      measureSign = new paper.Group();
      var c = new paper.Path.Circle(measurePoint, 5 / paper.view.zoom);
      c.style.strokeColor = "black";
      c.strokeScaling = false;
      measureSign.addChild(c);
      c = new paper.Path.Circle(measurePoint, 6 / paper.view.zoom);
      c.style.strokeColor = "white";
      c.strokeScaling = false;
      measureSign.addChild(c);
      uiLayer.addChild(measureSign);
    }
  };

  var updateMeasureShape0 = function () {
    if (measureShape0) {
      measureShape0.remove();
      measureShape0 = null;
    }
    if (measurePoint0) {
      measureShape0 = new paper.Group();
      var c = new paper.Path.Circle(measurePoint0, 5 / paper.view.zoom);
      c.style.strokeColor = "blue";
      c.strokeScaling = false;
      measureShape0.addChild(c);
      c = new paper.Path.Circle(measurePoint0, 6 / paper.view.zoom);
      c.style.strokeColor = "white";
      c.strokeScaling = false;
      measureShape0.addChild(c);
      uiLayer.addChild(measureShape0);
    }
  };

  var updateMeasureShape1 = function () {
    if (measureShape1) {
      measureShape1.remove();
      measureShape1 = null;
    }
    if (measurePoint1) {
      measureShape1 = new paper.Group();
      var c = new paper.Path.Circle(measurePoint1, 5 / paper.view.zoom);
      c.style.strokeColor = "blue";
      c.strokeScaling = false;
      measureShape1.addChild(c);
      c = new paper.Path.Circle(measurePoint1, 6 / paper.view.zoom);
      c.style.strokeColor = "white";
      c.strokeScaling = false;
      measureShape1.addChild(c);
      uiLayer.addChild(measureShape1);
    }
  };

  var updateMeasureLine = function () {
    if (!measureLine || !measurePoint0 || !measurePoint1) {
      return;
    }
    var pt = measurePoint0.subtract(measurePoint1);
    if (pt.x > 0) {
      pt.x = -pt.x;
      pt.y = -pt.y;
    }
    var angle = (Math.atan2(pt.x, pt.y) * 180) / Math.PI + 90;
    var l = measureLine.children[2];
    l.matrix.initialize();
    l.matrix = l.matrix
      .translate(measurePoint0.add(measurePoint1).divide(2.0))
      .rotate(-angle)
      .scale(1 / paper.view.zoom)
      .translate(0, 30);

    var distance = measureLine.children[0].length * scale;
    distance /= units[design_unit];
    distance = sizeToDisplay(distance);
    l.content = "" + distance + design_unit;

    $("#path_distance")
      .val("" + distance)
      .prop("disabled", false);
  };

  var updateMeasureSigns = function () {
    updateMeasureSign();
    updateMeasureShape0();
    updateMeasureShape1();
    updateMeasureLine();
  };

  SvgViewer.viewChanged = function () {
    updateMeasureSigns();
    updateIssues();
    doDrawGrid();
  };

  SvgViewer.addGrid = function () {
    drawGrid = true;
    gridGroup.visible = true;
    doDrawGrid();
  };

  SvgViewer.refreshGrid = function () {
    doDrawGrid();
  };

  SvgViewer.removeGrid = function () {
    drawGrid = false;
    gridGroup.visible = false;
  };

  var computeGridScale = function (
    size,
    w,
    zoom,
    zoomx,
    mm_scale,
    rule,
    orig_zoom
  ) {
    pow = Math.floor(
      Math.log((zoom * size * rule * mm_scale) / 2.0) / Math.log(10)
    );
    var rescale = Math.pow(10.0, pow);
    var grid_scale = (2.0 * rescale) / (size * mm_scale);
    if (grid_scale < 0.2 * rule * zoom) {
      rescale *= 5;
      grid_scale = (2.0 * rescale) / (size * mm_scale);
    } else if (grid_scale < 0.5 * rule * zoom) {
      rescale *= 2;
      grid_scale = (2.0 * rescale) / (size * mm_scale);
    }
    return { grid_scale: grid_scale, rescale: rescale };
  };

  var computeGridScaleMetric = function (
    size,
    w,
    zoom,
    zoomx,
    mm_scale,
    rule,
    orig_zoom
  ) {
    pow = Math.round(Math.log((size * zoom) / zoom0) / Math.log(10));
    var rescale = Math.pow(10.0, pow);
    var grid_scale = (rescale * zoomx) / (w * orig_zoom);
    if (grid_scale < 0.2 * rule * zoom) {
      rescale *= 5;
      grid_scale = (rescale * zoomx) / (w * orig_zoom);
    } else if (grid_scale < 0.5 * rule * zoom) {
      rescale *= 2;
      grid_scale = (rescale * zoomx) / (w * orig_zoom);
    }
    if (gridSizeCallback) {
      gridSizeCallback(((grid_scale * w) / (2 * zoomx)) * orig_zoom);
    }
    return { grid_scale: grid_scale, rescale: rescale };
  };

  var doDrawGrid = function () {
    if (!drawGrid) {
      return;
    }
    gridGroup.removeChildren();

    var jself = $("#viewer2d");
    var w = parseInt(jself.width(), 10);
    var h = parseInt(jself.height(), 10);

    //  Get the height of object in mm
    var _size = svgBBox.height;

    // Extend for zoom hack because getZoom returns this proportion
    var size = _size + svgDim * 20;

    // Extend for dimensions if they are drawn
    if (dimensionsGroup && dimensionsGroup.visible) {
      size += svgDim * 25;
    }

    // Multiply by design scale
    size *= scale;

    var mm_scale = units[design_unit];

    var ar = w / h;
    var orig_zoom = 1.0 / paper.view.zoom;

    var zoomx, zoomy;

    if (ar > 1.0) {
      zoomx = orig_zoom * ar;
      zoomy = orig_zoom;
    } else {
      zoomx = orig_zoom;
      zoomy = orig_zoom / ar;
    }

    var rule = 0.8;
    var grid_scale;
    var pow;
    var rescale;
    var zoom = zoomx;

    if (size == 0.0) {
      return;
    }

    if (mm_scale == 0.0) {
      /* 1 unit = mm_scale mm */
      return;
    }

    /* Metric grid */
    var scale_data = computeGridScaleFunc(
      size,
      w,
      zoom,
      zoomx,
      mm_scale,
      rule,
      orig_zoom
    );
    grid_scale = scale_data.grid_scale;
    rescale = scale_data.rescale;
    if (/*grid_scale < zoom && */ rescale > 0) {
      var x, y;

      var i, dim;

      dim = Math.ceil(zoom / grid_scale);

      /* Draw the grid */

      var bigGrid = new paper.CompoundPath();
      bigGrid.style.strokeColor = "#ffcc80";

      for (var i = -dim; i <= dim; i++) {
        x = w / 2 + parseInt((i * grid_scale * w) / (2 * zoomx));

        if (x >= 0 && x < w) {
          bigGrid.addChild(
            new paper.Path.Line(new paper.Point(x, 0), new paper.Point(x, h))
          );
        }

        y = h / 2 + parseInt((i * grid_scale * h) / (2 * zoomy));

        if (y >= 0 && y < h) {
          bigGrid.addChild(
            new paper.Path.Line(new paper.Point(0, y), new paper.Point(w, y))
          );
        }
      }

      grid_scale *= 0.1;
      dim = Math.ceil(zoom / grid_scale);

      var smallGrid = new paper.CompoundPath();
      smallGrid.style.strokeColor = "#ffcc80";

      for (var i = -dim; i <= dim; i++) {
        x = w / 2 + parseInt((i * grid_scale * w) / (2 * zoomx));

        if (x >= 0 && x < w) {
          smallGrid.addChild(
            new paper.Path.Line(new paper.Point(x, 0), new paper.Point(x, h))
          );
        }

        y = h / 2 + parseInt((i * grid_scale * h) / (2 * zoomy));

        if (y >= 0 && y < h) {
          smallGrid.addChild(
            new paper.Path.Line(new paper.Point(0, y), new paper.Point(w, y))
          );
        }
      }

      gridGroup.addChildren([smallGrid, bigGrid]);
      gridGroup.fitBounds(paper.view.bounds);

      var viewBox = paper.view.bounds.scale(paper.view.zoom);
      var stroke_scale = gridGroup.bounds.width / viewBox.width;
      bigGrid.style.strokeWidth = 2 * stroke_scale;
      smallGrid.style.strokeWidth = 1 * stroke_scale;
    }
  };

  SvgViewer.setGridSizeCallback = function (callback) {
    gridSizeCallback = callback;
  };

  SvgViewer.setScaleMetric = function () {
    zoom0 = 1 / paper.view.zoom;
    computeGridScaleFunc = computeGridScaleMetric;
  };

  SvgViewer.setZoomStep = function (step) {
    zoomStep = step;
  };

  SvgViewer.showModelDimensions = function () {
    addModelDimensions();
    updatePosition();
  };

  SvgViewer.hideModelDimensions = function () {
    removeModelDimensions();
    updatePosition();
  };

  /**
   * Sets new material for the viewer
   * @param {object} material - Viewer material
   */
  SvgViewer.set_material = function (material) {
    materialBackground = STATIC_URL + material.texture;
    materialCutColor = new paper.Color(
      material.cut[0],
      material.cut[1],
      material.cut[2]
    );
    materialLinearColor = new paper.Color(
      material.linear[0],
      material.linear[1],
      material.linear[2],
      material.linearOpacity
    );
    materialEngraveColor = new paper.Color(
      material.engrave[0],
      material.engrave[1],
      material.engrave[2],
      material.engraveOpacity
    );
    materialDeepColor = new paper.Color(
      material.deep[0],
      material.deep[1],
      material.deep[2],
      material.deepOpacity
    );

    updateMaterial(true);
  };

  SvgViewer.save = function (now) {
    if (!svgModified) {
      return;
    }
    function _save(now) {
      svgModified = false;
      if (SvgViewer.on_save_legend_start) {
        SvgViewer.on_save_legend_start();
      }
      // Clear selection before saving. Otherwise, the selection style will be saved too...
      //SvgViewer.unhighlight();
      //SvgViewer.clearSelection();

      var legend = getLegend();

      // Show warning if nothing is selected
      if (!legend || legend === -1) {
        $("#legendContinue").addClass("disabled");
        if (SvgViewer.on_save_legend_error) {
          if (!legend) {
            SvgViewer.on_save_legend_error("lasercut_all_ignored");
          }
        }
        return;
      }

      $("#legendContinue").removeClass("disabled");

      // Callback
      if (SvgViewer.on_save_legend) {
        SvgViewer.on_save_legend(legend, !now);
      }

      save_timeout = null;
    }

    if (save_timeout) {
      clearTimeout(save_timeout);
    }

    if (now) {
      setTimeout(function () {
        _save(true);
      }, 0);
    } else {
      save_timeout = setTimeout(_save, 500);
    }
  };

  SvgViewer.legendUpdated = function () {
    var lines = $(".legendLine");
    for (var i = 0; i < lines.length; i++) {
      var shouldBeRemoved = true;

      var style_id = parseInt($(lines[i]).data("style-id"));
      for (var j = 0; j < configModel.elems.length; j++) {
        if (style_id === configModel.elems[j].style_id) {
          shouldBeRemoved = false;
          break;
        }
      }

      if (shouldBeRemoved) {
        $(lines[i]).remove();
        $("#addToLegendGroup")
          .find("option[value=" + $(lines[i]).data("style-id") + "]")
          .remove();
      }
    }

    SvgViewer.clear_render_model();

    if (SvgViewer.on_legend_change) {
      SvgViewer.on_legend_change();
    }
    if (SvgViewer.on_allowed_changed) {
      var cutTypes = getCutTypes();
      var hasHidden = false;
      for (var i = 0; i < configModel.group_array.length; ++i) {
        for (var j in cutTypes) {
          var cutType = cutTypes[j];
          if (
            !cutTypeAllowed[cutType.stroke] ||
            !cutTypeAllowed[cutType.fill]
          ) {
            hasHidden = true;
          }
        }
      }
      SvgViewer.on_allowed_changed(hasHidden);
    }
    svgModified = true;
    SvgViewer.save();
  };

  var updateAllowed = function () {
    updateElementsMaterial(true);
    var cutTypes = getCutTypes();
    var hasHidden = false;
    for (var i = 0; i < configModel.group_array.length; ++i) {
      for (var j in cutTypes) {
        var cutType = cutTypes[j];
        var elem = configModel.group_array[i]._lasercut_styles[j];
        var stroke_visible =
          cutTypeAllowed[cutType.stroke] &&
          !(cutType.stroke == 0 || cutType.stroke == 5);
        var fill_visible =
          cutTypeAllowed[cutType.fill] &&
          !(cutType.fill == 0 || cutType.fill == 5);
        if (!cutTypeAllowed[cutType.stroke] || !cutTypeAllowed[cutType.fill]) {
          hasHidden = true;
        }
        var bboxset = [];
        var list = elem.children;
        var all_list = [];
        for (var j = list.length - 1; j >= 0; --j) {
          var child = list[j];
          if (child._lasercut_shape) {
            all_list.push(child);
          } else {
            all_list = all_list.concat(child.children);
          }
        }
        list = all_list;

        for (var j = list.length - 1; j >= 0; --j) {
          var child = list[j];
          if (!child._lasercut_shape || bboxset[child._lasercut_id]) {
            continue;
          }
          bboxset[child._lasercut_id] = true;
          if (!stroke_visible && !fill_visible) {
            configModel.elemsBBox[child._lasercut_id] = null;
          } else if (!configModel.elemsBBox[child._lasercut_id]) {
            if (
              stroke_visible &&
              (cutType.stroke == 2 || cutType.stroke == 4)
            ) {
              configModel.elemsBBox[child._lasercut_id] = boundsToBBox(
                getShapeStrokeBounds(child._lasercut_shape)
              );
            } else {
              configModel.elemsBBox[child._lasercut_id] = boundsToBBox(
                getShapeBounds(child._lasercut_shape)
              );
            }
          }
        }
      }
    }
    if (SvgViewer.on_allowed_changed) {
      SvgViewer.on_allowed_changed(hasHidden);
    }
    updateSVGBBox();
    SvgViewer.legendUpdated();
  };

  SvgViewer.setAllowedCutTypes = function (allowed) {
    var list = allowed.split(",");
    var changed = false;
    for (var i = 1; i < 5; ++i) {
      if (list.indexOf("" + i) >= 0) {
        if (!cutTypeAllowed[i]) {
          changed = true;
        }
        cutTypeAllowed[i] = true;
      } else {
        if (cutTypeAllowed[i]) {
          changed = true;
        }
        cutTypeAllowed[i] = false;
      }
    }
    if (changed) {
      updateAllowed();
    }
    return changed;
  };

  var pathIsOpen = function (path) {
    return !(path.flags & 1);
  };

  SvgViewer.getOpenCuts = function () {
    var list = [];
    var model = renderModel.lsrModel ? renderModel : configModel;
    var cutTypes = getCutTypes(model);
    for (var i = model.elems.length - 1; i >= 0; --i) {
      var elem = model.elems[i];
      var cutType = cutTypes[elem.style_id];
      if (cutType.stroke != 1) {
        continue;
      }
      var closedPath = true;
      for (var j = 0; j < elem.tn; ++j) {
        var ti = elem.ti + j;
        if (model.lsrModel.paths[ti].pn <= 1) {
          continue;
        }
        if (pathIsOpen(model.lsrModel.paths[ti])) {
          closedPath = false;
          break;
        }
      }
      if (!closedPath) {
        list.push(elem);
      }
    }
    return list;
  };

  SvgViewer.setIssues = function (issues) {
    var model = renderModel.lsrModel ? renderModel : configModel;
    for (var i = model.elems.length - 1; i >= 0; --i) {
      var elem = model.elems[i];
      if (issues[elem.id]) {
        elem.issues = issues[elem.id];
      } else {
        elem.issues = [];
        elem.issue_group = null;
      }
    }
  };

  SvgViewer.hasIssues = function () {
    var model = activeModel;
    for (var i = model.elems.length - 1; i >= 0; --i) {
      var elem = model.elems[i];
      if (elem.issues && elem.issues.length && elem.issues.length > 0) {
        return true;
      }
    }
    return false;
  };

  var getShapesWithIssues = function () {
    var model = renderModel.lsrModel ? renderModel : configModel;
    var list = [];
    for (var i = model.elems.length - 1; i >= 0; --i) {
      var elem = model.elems[i];
      if (elem.issues && elem.issues.length && elem.issues.length > 0) {
        list.push(elem);
      }
    }
    return list;
  };

  var clearIssues = function () {
    $("#lasercut-issues-widget .issuesList").empty();
    if (issuesLayer) {
      issuesLayer.removeChildren();
    }
  };

  var updateIssues = function () {
    if (!issuesLayer) return;
    for (var i = 0; i < issuesLayer.children.length; ++i) {
      var hint = issuesLayer.children[i];
      var r = 15 / paper.view.zoom;
      var r0 = 4 / paper.view.zoom;
      hint.children[0].replaceWith(
        new paper.Path.Circle(hint._lasercut_center.add(r, -r), r)
      );
      hint.children[0].style.strokeColor = "white";
      hint.children[0].style.fillColor = "#49E";
      hint.children[0].strokeScaling = false;

      hint.children[1].replaceWith(
        new paper.Path.Circle(hint._lasercut_center, r0 + 1 / paper.view.zoom)
      );
      hint.children[1].style.strokeColor = "red";
      hint.children[1].strokeScaling = false;
      hint.children[2].replaceWith(
        new paper.Path.Circle(hint._lasercut_center, r0 + 1 / paper.view.zoom)
      );
      hint.children[2].style.strokeColor = "white";
      hint.children[2].strokeScaling = false;

      var l = hint.children[3];
      l.matrix.initialize();
      l.matrix = l.matrix
        .translate(hint._lasercut_center.add(r, -r))
        .scale(1 / paper.view.zoom)
        .translate(0, 8);
    }
  };

  SvgViewer.hideIssues = function () {
    $("#lasercut-issues-widget").hide();
    clearIssues();
    isShowIssuesModeEnabled = false;
  };

  SvgViewer.displayIssues = function () {
    clearIssues();
    var issueslist = $("#lasercut-issues-widget .issuesList").first();
    var issues = getShapesWithIssues();
    var index = 1;
    var model = renderModel.lsrModel ? renderModel : configModel;
    for (var i = 0; i < issues.length; ++i, ++index) {
      var elem = issues[i];
      issueslist.append(
        '<li data-issueid="' +
          elem.id +
          '">' +
          index +
          ": The path is not closed</li>"
      );

      var found = false;
      var ti;
      for (var j = 0; j < elem.tn; ++j) {
        ti = elem.ti + j;
        if (model.lsrModel.paths[ti].pn <= 1) {
          continue;
        }
        found = true;
        break;
      }
      if (found) {
        var path = model.lsrModel.paths[ti];
        point = model.lsrModel.points[path.pi];
        var center = new paper.Point(
          model.lsrModel.points[path.pi].x,
          model.lsrModel.points[path.pi].y
        );
        var hint = new paper.Group();
        hint._lasercut_center = center;
        hint._lasercut_shape = elem;
        elem.issue_group = hint;
        var r = 6 / paper.view.zoom;
        hint.addChild(new paper.Path());
        hint.addChild(new paper.Path());
        hint.addChild(new paper.Path());

        var l = new paper.PointText();
        l.fillColor = "#FFF";
        l.fontSize = 25;
        l.justification = "center";
        l.fontFamily = "Open Sans, sans-serif";
        l.content = "" + index;
        hint.addChild(l);
        issuesLayer.addChild(hint);
      }
    }
    $("li", issueslist).click(function () {
      var id = $(this).data("issueid");
      SvgViewer.clearSelection();
      SvgViewer.addToSelection(model.elems[id]);
      var bounds = model.elems[id].paths[0].bounds;
      for (var i = 1; i < model.elems[id].paths.length; ++i) {
        bounds.unite(model.elems[id].paths[i]);
      }
      bounds = bounds.unite(model.elems[id].issue_group.bounds);
      zoomToRect(bounds);
      SvgViewer.viewChanged();
    });
    updateIssues();
  };

  SvgViewer.getBBox = function () {
    return $.extend({}, svgBBox);
  };

  SvgViewer.setModified = function (value) {
    svgModified = value;
  };

  SvgViewer.getScale = function () {
    return scale;
  };

  SvgViewer.getMeasureLine = function () {
    if (measureLine === null) {
      return null;
    }
    return measureLine.children[0].length * scale;
  };

  SvgViewer.log = function (msg) {
    log(msg);
  };

  SvgViewer.load_binary_resource =
    Sculpteo3DViewerCommon.prototype.load_binary_resource;
  SvgViewer.buildModel = function (mesh, callBack) {
    callBack();
    return {};
  };

  SvgViewer.setRenderLayerEnabled = function (enabled) {
    enableRenderLayer = enabled;
    if (!enableRenderLayer && activeLayer == renderLayer) {
      configLayer.visible = true;
      renderLayer.visible = false;
      activeLayer = configLayer;
      activeModel = configModel;
    }
  };

  SvgViewer.showRenderModel = function (show) {
    if (show && activeLayer === configLayer) {
      configLayer.visible = false;
      renderLayer.visible = true;
      activeLayer = renderLayer;
      activeModel = renderModel;
    } else if (!show && activeLayer === renderLayer) {
      configLayer.visible = true;
      renderLayer.visible = false;
      activeLayer = configLayer;
      activeModel = configModel;
    }
  };

  SvgViewer.clear_render_model = function (path) {
    if (activeLayer === renderLayer) {
      configLayer.visible = true;
      renderLayer.visible = false;
      activeLayer = configLayer;
      activeModel = configModel;
    }
    renderModel = {
      group_array: [],
      elems: [],
      lsrModel: null,
      elemsBBox: [],
      cutTypes: null,
    };
    renderLayer.removeChildren();
  };

  SvgViewer.load_render_model = function (path, callback) {
    var _this = this;
    //if (!path.endsWith("svg") && !(path.indexOf("get_svg_printer_file") >= 0)) {
    Sculpteo3DViewerCommon.prototype.__loadModel.call(
      _this,
      path,
      "model",
      null,
      null,
      function (model, name) {
        loadRenderModel(model.mesh);
        if (callback) {
          callback();
        }
      }
    );
    //}
  };

  SvgViewer.reset_model_position = function () {
    if (svgQuestionmark && svgQuestionmark.visible) {
      return;
    }
    updatePosition();
    SvgViewer.viewChanged();
  };

  SvgViewer.zoom_out = function () {
    if (svgQuestionmark && svgQuestionmark.visible) {
      return;
    }
    paper.view.zoom = paper.view.zoom / 1.05;
    SvgViewer.viewChanged();
  };

  SvgViewer.zoom_in = function () {
    if (svgQuestionmark && svgQuestionmark.visible) {
      return;
    }
    paper.view.zoom = paper.view.zoom * 1.05;
    SvgViewer.viewChanged();
  };

  /**
   * Loads the desired svg file into the 2D viewer and initializes necessary event handlers
   * @param {string} path - Path to the SVG file to load
   * @param {bool} [legendEnabled] - Whether to load the viewer in legend edit mode or not
   * @param {bool} [validationMode] - Whether this is started in production validation mode
   */
  SvgViewer.load_svg_file = function (path, legendEnabled, validationMode) {
    isLoaded = false;
    if (SvgViewer.on_svg_loading_start) {
      SvgViewer.on_svg_loading_start();
    }

    if (validationMode) {
      featureSupport.PointText = true;
      featureSupport.Shape = true;
    }

    $("#viewer2dpaper").empty();
    $(".colorLegend").empty();

    paper.remove();
    paper.setup("viewer2dpaper");
    paper.settings.handleSize = 0;

    isLegendModeEnabled = legendEnabled;
    var _this = this;

    var initialize = function (mesh) {
      $(".zoomout").on("click", function () {
        if (svgQuestionmark && svgQuestionmark.visible) {
          return;
        }
        paper.view.zoom = paper.view.zoom / 1.05;
        SvgViewer.viewChanged();
      });

      $(".zoomreset").on("click", function () {
        if (svgQuestionmark && svgQuestionmark.visible) {
          return;
        }
        updatePosition();
        SvgViewer.viewChanged();
      });

      $(".zoomin").on("click", function () {
        if (svgQuestionmark && svgQuestionmark.visible) {
          return;
        }
        paper.view.zoom = paper.view.zoom * 1.05;
        SvgViewer.viewChanged();
      });

      $("#viewer2dpaper").bind("mousewheel DOMMouseScroll", function (event) {
        if (svgQuestionmark && svgQuestionmark.visible) {
          event.preventDefault();
          return;
        }
        if (event.target != this) {
          return;
        }

        var mousePos = new paper.Point(
          event.originalEvent.offsetX,
          event.originalEvent.offsetY
        );
        var oldZoom = paper.view.zoom;
        var oldCenter = paper.view.center;
        var viewPos = paper.view.viewToProject(mousePos);

        var newZoom;
        if (
          event.originalEvent.wheelDelta > 0 ||
          event.originalEvent.detail < 0
        ) {
          // scroll up
          newZoom = oldZoom * (1.0 + zoomStep);
        } else {
          // scroll down
          newZoom = oldZoom / (1.0 + zoomStep);
        }

        var zoomScale = oldZoom / newZoom;
        var centerAdjust = viewPos.subtract(oldCenter); //.add(svgBboxOutlineRect.center);
        var offset = viewPos
          .subtract(centerAdjust.multiply(zoomScale))
          .subtract(oldCenter);

        paper.view.zoom = newZoom;
        paper.view.center = paper.view.center.add(offset);

        SvgViewer.viewChanged();

        event.preventDefault();
      });

      $("#addToLegendGroup").on("change", function () {
        var $option = $("#addToLegendGroup").find("option:selected");

        if (!$option.is("disabled")) {
          var styleIdx = parseInt($option.val(), 10);

          if (styleIdx === 0) {
            // TODO : StrokeWidth > 1 ==> Engrave
            var fillCutType, strokeCutType;
            if (selectionSet.length === 1) {
              fillCutType = selectionSet[0].paths[0].style.fillColor ? 2 : 5;
              strokeCutType = selectionSet[0].paths[0].style.strokeColor
                ? 1
                : 5;
            } else {
              fillCutType = 2;
              strokeCutType = 1;
            }

            styleIdx = createLegendLine({
              fillColor: getColor(intToCutType[fillCutType]),
              fillCutType: fillCutType,
              strokeColor: getColor(intToCutType[strokeCutType]),
              strokeCutType: strokeCutType,
              elems: selectionSet,
            });
          }
          var cutTypes = getCutTypes();
          var style = cutTypes[styleIdx];

          for (var i = 0; i < selectionSet.length; i++) {
            selectionSet[i].style_id = styleIdx;
            removeElemFromSelection(selectionSet[i]);

            for (var j = 0; j < selectionSet[i].paths.length; ++j) {
              var parent = selectionSet[i].paths[j].parent;
              while (!parent._lasercut_styles) {
                parent = parent.parent;
              }
              if (selectionSet[i].paths[j].className == "Path") {
                parent._lasercut_styles[styleIdx].children[0].addChild(
                  selectionSet[i].paths[j]
                );
                selectionSet[i].paths[j]._lasercut_stroke = style.strokeColor
                  ? parent._lasercut_styles[styleIdx].style.strokeColor.clone()
                  : null;
                selectionSet[i].paths[j]._lasercut_fill = style.fillColor
                  ? parent._lasercut_styles[styleIdx].style.fillColor
                  : null;
              } else {
                parent._lasercut_styles[styleIdx].addChild(
                  selectionSet[i].paths[j]
                );
                selectionSet[i].paths[j].style.strokeColor = style.stroke_color;
                selectionSet[i].paths[j]._lasercut_stroke = style.stroke_color
                  ? selectionSet[i].paths[j].style.strokeColor.clone()
                  : null;
                selectionSet[i].paths[j].style.fillColor = style.fill_color;
                selectionSet[i].paths[j]._lasercut_fill = style.fill_color
                  ? selectionSet[i].paths[j].style.fillColor
                  : null;
              }
              if (style.stroke_color == null && style.fill_color == null) {
                selectionSet[i].paths[j].style.fillColor = "white";
              }
            }

            if (
              (style.stroke == 0 || style.stroke == 5) &&
              (style.fill == 0 || style.fill == 5)
            ) {
              configModel.elemsBBox[selectionSet[i].id] = null;
            } else if (style.stroke == 2 || style.stroke == 4) {
              configModel.elemsBBox[selectionSet[i].id] = boundsToBBox(
                getShapeStrokeBounds(selectionSet[i])
              );
            } else {
              configModel.elemsBBox[selectionSet[i].id] = boundsToBBox(
                getShapeBounds(selectionSet[i])
              );
            }
          }
          updateAfterSelectionChange();

          updateSVGBBox();

          SvgViewer.legendUpdated();
        }

        $option.attr("selected", false);
        $($("#addToLegendGroup").find("option")[0]).attr("selected", true);
      });

      if (SvgViewer.on_svg_loaded) {
        SvgViewer.on_svg_loaded();
      }

      legendInit(mesh);
    };

    if (!path.endsWith("svg") && !(path.indexOf("get_svg_printer_file") >= 0)) {
      Sculpteo3DViewerCommon.prototype.__loadModel.call(
        _this,
        path,
        "model",
        null,
        null,
        function (model, name) {
          initialize(model.mesh);
        }
      );
    } else {
      $.ajax({
        url: path,
        success: function (data) {
          lasercutCutMap = [];
          var fixNumbers = function (root) {
            if (root.id && root.id != "") {
              var num = parseInt(root.id);
              if (!isNaN(num)) {
                root.id = "P" + num;
                lasercutCutMap[num] = {
                  stroke: root.getAttribute("lasercut_stroke_type"),
                  fill: root.getAttribute("lasercut_fill_type"),
                };
              } else {
                if (root.id.startsWith("P")) {
                  num = parseInt(root.id.substring(1));
                  if (!isNaN(num)) {
                    lasercutCutMap[num] = {
                      stroke: root.getAttribute("lasercut_stroke_type"),
                      fill: root.getAttribute("lasercut_fill_type"),
                    };
                  } else {
                  }
                }
              }
            }
            if (root.children) {
              for (var i = 0; i < root.children.length; ++i) {
                fixNumbers(root.children[i]);
              }
            }
          };

          fixNumbers(data);

          paper.project.importSVG(data, function () {
            initialize(null);
          });
        },
      });
    }
  };

  SvgViewer.on_save_legend_start = null;

  SvgViewer.on_save_legend = null;

  SvgViewer.on_save_legend_error = null;

  SvgViewer.on_svg_loading_start = null;

  SvgViewer.on_svg_loaded = null;

  SvgViewer.on_viewer_initialized = null;

  SvgViewer.on_legend_change = null;

  SvgViewer.on_legend_reset = null;

  SvgViewer.on_scale_update = null;

  SvgViewer.on_allowed_changed = null;

  return SvgViewer;
})(SvgViewer || {});
